!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.Chatkit = t();
}(this, function () {
  "use strict";

  "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self && self;
  var e,
      t,
      n = (function (e, t) {
    var n;
    n = function n() {
      return function (e) {
        var t = {};

        function n(r) {
          if (t[r]) return t[r].exports;
          var o = t[r] = {
            i: r,
            l: !1,
            exports: {}
          };
          return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }

        return n.m = e, n.c = t, n.d = function (e, t, r) {
          n.o(e, t) || Object.defineProperty(e, t, {
            configurable: !1,
            enumerable: !0,
            get: r
          });
        }, n.n = function (e) {
          var t = e && e.__esModule ? function () {
            return e.default;
          } : function () {
            return e;
          };
          return n.d(t, "a", t), t;
        }, n.o = function (e, t) {
          return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 10);
      }([function (e, t, n) {
        function r(e) {
          var t = {};
          if (!e) return t;

          for (var n = 0, r = e.split("\r\n"); n < r.length; n++) {
            var o = r[n],
                i = o.indexOf(": ");

            if (i > 0) {
              var s = o.substring(0, i),
                  u = o.substring(i + 2);
              t[s] = u;
            }
          }

          return t;
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.responseToHeadersObject = r;

        var o = function () {
          function e(e, t, n) {
            this.statusCode = e, this.headers = t, this.info = n;
          }

          return e.fromXHR = function (t) {
            var n = t.responseText;

            try {
              n = JSON.parse(t.responseText);
            } catch (e) {}

            return new e(t.status, r(t.getAllResponseHeaders()), n);
          }, e;
        }();

        t.ErrorResponse = o;

        var i = function () {
          return function (e) {
            this.error = e;
          };
        }();

        t.NetworkError = i, function (e) {
          e[e.UNSENT = 0] = "UNSENT", e[e.OPENED = 1] = "OPENED", e[e.HEADERS_RECEIVED = 2] = "HEADERS_RECEIVED", e[e.LOADING = 3] = "LOADING", e[e.DONE = 4] = "DONE";
        }(t.XhrReadyState || (t.XhrReadyState = {}));
      }, function (e, t, n) {
        var r;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), function (e) {
          e[e.VERBOSE = 1] = "VERBOSE", e[e.DEBUG = 2] = "DEBUG", e[e.INFO = 3] = "INFO", e[e.WARNING = 4] = "WARNING", e[e.ERROR = 5] = "ERROR";
        }(r = t.LogLevel || (t.LogLevel = {}));

        var o = function () {
          function e(e) {
            void 0 === e && (e = 2), this.threshold = e;
            var t = Array(),
                n = "--------------------------------------------------------------------------------";
            window.console.group || (window.console.group = function (e) {
              t.push(e), window.console.log("%c \nBEGIN GROUP: %c", n, e);
            }), window.console.groupEnd || (window.console.groupEnd = function () {
              window.console.log("END GROUP: %c\n%c", t.pop(), n);
            });
          }

          return e.prototype.verbose = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            this.log(window.console.log, r.VERBOSE, e);
          }, e.prototype.debug = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            this.log(window.console.log, r.DEBUG, e);
          }, e.prototype.info = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            this.log(window.console.info, r.INFO, e);
          }, e.prototype.warn = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            this.log(window.console.warn, r.WARNING, e);
          }, e.prototype.error = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }

            this.log(window.console.error, r.ERROR, e);
          }, e.prototype.log = function (e, t, n) {
            var o = this;

            if (t >= this.threshold) {
              var i = "Logger." + r[t];
              n.length > 1 ? (window.console.group(), n.forEach(function (t) {
                o.errorAwareLog(e, t, i);
              }), window.console.groupEnd()) : this.errorAwareLog(e, n[0], i);
            }
          }, e.prototype.errorAwareLog = function (e, t, n) {
            if (void 0 !== t && t.info && t.info.error_uri) {
              var r = t.info.error_description;
              e((r || "An error has occurred") + ". More information can be found at " + t.info.error_uri + ". Error object: ", t);
            } else e(n + ": ", t);
          }, e;
        }();

        t.ConsoleLogger = o;

        var i = function () {
          function e() {}

          return e.prototype.verbose = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }
          }, e.prototype.debug = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }
          }, e.prototype.info = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }
          }, e.prototype.warn = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }
          }, e.prototype.error = function () {
            for (var e = [], t = 0; t < arguments.length; t++) {
              e[t] = arguments[t];
            }
          }, e;
        }();

        t.EmptyLogger = i;
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0);

        t.createRetryStrategyOptionsOrDefault = function (e) {
          var t = e.initialTimeoutMillis || 1e3,
              n = e.maxTimeoutMillis || 5e3,
              r = -1;
          return void 0 !== e.limit && null != e.limit && (r = e.limit), {
            increaseTimeout: void 0 !== e.increaseTimeout ? e.increaseTimeout : function (e) {
              return 2 * e > n ? n : 2 * e;
            },
            initialTimeoutMillis: t,
            limit: r,
            maxTimeoutMillis: n
          };
        };

        var o = function () {
          return function (e) {
            this.waitTimeMillis = e;
          };
        }();

        t.Retry = o;

        var i = function () {
          return function (e) {
            this.error = e;
          };
        }();

        t.DoNotRetry = i;

        var s = function () {
          function e(e, t, n) {
            this.options = e, this.logger = t, this.retryUnsafeRequests = n, this.currentRetryCount = 0, this.initialTimeoutMillis = e.initialTimeoutMillis, this.maxTimeoutMillis = e.maxTimeoutMillis, this.limit = e.limit, this.increaseTimeoutFunction = e.increaseTimeout, this.currentBackoffMillis = this.initialTimeoutMillis;
          }

          return e.prototype.attemptRetry = function (e) {
            return this.logger.verbose(this.constructor.name + ": Error received", e), this.currentRetryCount >= this.limit && this.limit >= 0 ? (this.logger.verbose(this.constructor.name + ": Retry count is over the maximum limit: " + this.limit), new i(e)) : e instanceof r.ErrorResponse && e.headers["Retry-After"] ? (this.logger.verbose(this.constructor.name + ": Retry-After header is present, retrying in " + e.headers["Retry-After"]), new o(1e3 * parseInt(e.headers["Retry-After"], 10))) : e instanceof r.NetworkError || e instanceof r.ErrorResponse && ("GET" === (t = (t = e.headers["Request-Method"]).toUpperCase()) || "HEAD" === t || "OPTIONS" === t || "SUBSCRIBE" === t) || this.retryUnsafeRequests ? this.shouldSafeRetry(e) : e instanceof r.NetworkError ? this.shouldSafeRetry(e) : (this.logger.verbose(this.constructor.name + ": Error is not retryable", e), new i(e));
            var t;
          }, e.prototype.shouldSafeRetry = function (e) {
            return e instanceof r.NetworkError ? (this.logger.verbose(this.constructor.name + ": It's a Network Error, will retry", e), new o(this.calulateMillisToRetry())) : e instanceof r.ErrorResponse && e.statusCode >= 500 && e.statusCode < 600 ? (this.logger.verbose(this.constructor.name + ": Error 5xx, will retry"), new o(this.calulateMillisToRetry())) : (this.logger.verbose(this.constructor.name + ": Error is not retryable", e), new i(e));
          }, e.prototype.calulateMillisToRetry = function () {
            return this.currentBackoffMillis = this.increaseTimeoutFunction(this.currentBackoffMillis), this.logger.verbose(this.constructor.name + ": Retrying in " + this.currentBackoffMillis + "ms"), this.currentBackoffMillis;
          }, e;
        }();

        t.RetryResolution = s;
      }, function (e, t, n) {
        var r = this && this.__assign || Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var o in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var o = n(1),
            i = n(4),
            s = n(5),
            u = n(6),
            a = n(11),
            c = n(12),
            h = n(7),
            l = n(13),
            d = n(14),
            f = n(8),
            p = function () {
          function e(e) {
            this.options = e, this.host = e.host.replace(/(\/)+$/, ""), this.logger = e.logger || new o.ConsoleLogger(), this.websocketTransport = new d.default(this.host), this.httpTransport = new l.default(this.host, e.encrypted), this.sdkProduct = e.sdkProduct || "unknown", this.sdkVersion = e.sdkVersion || "unknown", this.sdkPlatform = navigator ? "ReactNative" === navigator.product ? "react-native" : "web" : "node";
          }

          return e.prototype.request = function (e, t) {
            var n = this;
            return e.tokenProvider ? e.tokenProvider.fetchToken(t).then(function (t) {
              return void 0 !== e.headers ? e.headers.Authorization = "Bearer " + t : e.headers = ((n = {}).Authorization = "Bearer " + t, n), e;
              var n;
            }).then(function (e) {
              return n.makeRequest(e);
            }) : this.makeRequest(e);
          }, e.prototype.subscribeResuming = function (e, t, n, o, i, u) {
            var l = c.replaceMissingListenersWithNoOps(n),
                d = a.subscribeStrategyListenersFromSubscriptionListeners(l),
                p = !1;
            return s.createResumingStrategy(o, h.createTokenProvidingStrategy(f.createTransportStrategy(e, this.websocketTransport, this.logger), this.logger, u), this.logger, i)({
              onEnd: d.onEnd,
              onError: d.onError,
              onEvent: d.onEvent,
              onOpen: function onOpen(e) {
                p || (p = !0, d.onOpen(e)), l.onSubscribe();
              },
              onRetrying: d.onRetrying
            }, r({}, t, this.infoHeaders()));
          }, e.prototype.subscribeNonResuming = function (e, t, n, o, i) {
            var s = c.replaceMissingListenersWithNoOps(n),
                l = a.subscribeStrategyListenersFromSubscriptionListeners(s),
                d = !1;
            return u.createRetryingStrategy(o, h.createTokenProvidingStrategy(f.createTransportStrategy(e, this.websocketTransport, this.logger), this.logger, i), this.logger)({
              onEnd: l.onEnd,
              onError: l.onError,
              onEvent: l.onEvent,
              onOpen: function onOpen(e) {
                d || (d = !0, l.onOpen(e)), s.onSubscribe();
              },
              onRetrying: l.onRetrying
            }, r({}, t, this.infoHeaders()));
          }, e.prototype.infoHeaders = function () {
            return {
              "X-SDK-Language": "javascript",
              "X-SDK-Platform": this.sdkPlatform,
              "X-SDK-Product": this.sdkProduct,
              "X-SDK-Version": this.sdkVersion
            };
          }, e.prototype.makeRequest = function (e) {
            var t = this;
            return i.executeNetworkRequest(function () {
              return t.httpTransport.request(r({}, e, {
                headers: r({}, e.headers, t.infoHeaders())
              }));
            }, e).catch(function (e) {
              throw t.logger.error(e), e;
            });
          }, e;
        }();

        t.BaseClient = p;
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0);

        function o(e, t, n) {
          return e.onreadystatechange = function () {
            4 === e.readyState && (e.status >= 200 && e.status < 300 ? t(e.response) : 0 !== e.status ? n(r.ErrorResponse.fromXHR(e)) : n(new r.NetworkError("No Connection")));
          }, e;
        }

        t.executeNetworkRequest = function (e, t) {
          return new Promise(function (n, r) {
            !function (e, t) {
              t.json ? e.send(JSON.stringify(t.json)) : e.send(t.body);
            }(o(e(), n, r), t);
          });
        }, t.sendRawRequest = function (e) {
          return new Promise(function (t, n) {
            var r = o(new window.XMLHttpRequest(), t, n);
            if (r.open(e.method.toUpperCase(), e.url, !0), e.headers) for (var i in e.headers) {
              e.headers.hasOwnProperty(i) && r.setRequestHeader(i, e.headers[i]);
            }
            r.send(e.body);
          });
        };
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0),
            o = n(2);

        t.createResumingStrategy = function (e, t, n, r) {
          var s = o.createRetryStrategyOptionsOrDefault(e),
              u = new o.RetryResolution(s, n);
          return function (e, r) {
            return new i(n, r, t, e, u);
          };
        };

        var i = function () {
          return function (e, t, n, r, o) {
            var i = this;
            this.unsubscribe = function () {
              i.state.unsubscribe();
            }, this.onTransition = function (e) {
              i.state = e;
            }, this.state = new s(this.onTransition, e, t, n, r, o);
          };
        }(),
            s = function () {
          function e(e, t, n, r, o, i, s) {
            var c = this;
            this.onTransition = e, this.logger = t, this.headers = n, this.nextSubscribeStrategy = r, this.listeners = o, this.retryResolution = i, this.initialEventId = s;
            var l = s;
            t.verbose("ResumingSubscription: transitioning to OpeningSubscriptionState"), l && (n["Last-Event-Id"] = l, t.verbose("ResumingSubscription: initialEventId is " + l)), this.underlyingSubscription = r({
              onEnd: function onEnd(n) {
                e(new h(t, o, n));
              },
              onError: function onError(s) {
                e(new a(s, e, t, n, o, r, i, l));
              },
              onEvent: function onEvent(e) {
                l = e.eventId, o.onEvent(e);
              },
              onOpen: function onOpen(n) {
                e(new u(t, n, o, c.underlyingSubscription, e));
              },
              onRetrying: o.onRetrying
            }, n);
          }

          return e.prototype.unsubscribe = function () {
            this.onTransition(new c(this.logger)), this.underlyingSubscription.unsubscribe();
          }, e;
        }(),
            u = function () {
          function e(e, t, n, r, o) {
            this.logger = e, this.headers = t, this.listeners = n, this.underlyingSubscription = r, this.onTransition = o, e.verbose("ResumingSubscription: transitioning to OpenSubscriptionState"), n.onOpen(t);
          }

          return e.prototype.unsubscribe = function () {
            this.onTransition(new c(this.logger)), this.underlyingSubscription.unsubscribe();
          }, e;
        }(),
            a = function () {
          function e(e, t, n, i, s, a, c, d) {
            var f = this;
            this.onTransition = t, this.logger = n, this.headers = i, this.listeners = s, this.nextSubscribeStrategy = a, this.retryResolution = c, n.verbose("ResumingSubscription: transitioning to ResumingSubscriptionState");

            var p = function p(e, i) {
              s.onRetrying();
              var u,
                  a = ((u = e) instanceof r.ErrorResponse && (u.headers["Request-Method"] = "SUBSCRIBE"), c.attemptRetry(u));
              a instanceof o.Retry ? f.timeout = window.setTimeout(function () {
                g(i);
              }, a.waitTimeMillis) : t(new l(n, s, e));
            },
                g = function g(e) {
              n.verbose("ResumingSubscription: trying to re-establish the subscription"), e && (n.verbose("ResumingSubscription: lastEventId: " + e), i["Last-Event-Id"] = e), f.underlyingSubscription = a({
                onEnd: function onEnd(e) {
                  t(new h(n, s, e));
                },
                onError: function onError(e) {
                  p(e, d);
                },
                onEvent: function onEvent(e) {
                  d = e.eventId, s.onEvent(e);
                },
                onOpen: function onOpen(e) {
                  t(new u(n, e, s, f.underlyingSubscription, t));
                },
                onRetrying: s.onRetrying
              }, i);
            };

            p(e, d);
          }

          return e.prototype.unsubscribe = function () {
            this.onTransition(new c(this.logger)), window.clearTimeout(this.timeout), this.underlyingSubscription.unsubscribe();
          }, e;
        }(),
            c = function () {
          function e(e, t) {
            this.logger = e, e.verbose("ResumingSubscription: transitioning to EndingSubscriptionState");
          }

          return e.prototype.unsubscribe = function () {
            throw new Error("Subscription is already ending");
          }, e;
        }(),
            h = function () {
          function e(e, t, n) {
            this.logger = e, this.listeners = t, e.verbose("ResumingSubscription: transitioning to EndedSubscriptionState"), t.onEnd(n);
          }

          return e.prototype.unsubscribe = function () {
            throw new Error("Subscription has already ended");
          }, e;
        }(),
            l = function () {
          function e(e, t, n) {
            this.logger = e, this.listeners = t, e.verbose("ResumingSubscription: transitioning to FailedSubscriptionState", n), t.onError(n);
          }

          return e.prototype.unsubscribe = function () {
            throw new Error("Subscription has already ended");
          }, e;
        }();
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0),
            o = n(2);

        t.createRetryingStrategy = function (e, t, n) {
          var r = o.createRetryStrategyOptionsOrDefault(e),
              s = new o.RetryResolution(r, n);
          return function (e, r) {
            return new i(n, r, e, t, s);
          };
        };

        var i = function () {
          return function (e, t, n, r, o) {
            var i = this;
            this.unsubscribe = function () {
              i.state.unsubscribe();
            }, this.onTransition = function (e) {
              i.state = e;
            }, this.state = new s(this.onTransition, e, t, n, r, o);
          };
        }(),
            s = function () {
          function e(e, t, n, r, o, i) {
            var s = this;
            this.logger = t, this.headers = n, this.listeners = r, this.nextSubscribeStrategy = o, this.retryResolution = i, t.verbose("RetryingSubscription: transitioning to OpeningSubscriptionState"), this.underlyingSubscription = o({
              onEnd: function onEnd(n) {
                return e(new c(t, r, n));
              },
              onError: function onError(s) {
                return e(new u(s, e, t, n, r, o, i));
              },
              onEvent: r.onEvent,
              onOpen: function onOpen(n) {
                return e(new a(t, r, n, s.underlyingSubscription, e));
              },
              onRetrying: r.onRetrying
            }, n);
          }

          return e.prototype.unsubscribe = function () {
            throw this.underlyingSubscription.unsubscribe(), new Error("Method not implemented.");
          }, e;
        }(),
            u = function () {
          function e(e, t, n, i, s, u, l) {
            var d = this;
            this.onTransition = t, this.logger = n, this.headers = i, this.listeners = s, this.nextSubscribeStrategy = u, this.retryResolution = l, n.verbose("RetryingSubscription: transitioning to RetryingSubscriptionState");

            var f = function f(e) {
              s.onRetrying();
              var i,
                  u = ((i = e) instanceof r.ErrorResponse && (i.headers["Request-Method"] = "SUBSCRIBE"), l.attemptRetry(i));
              u instanceof o.Retry ? d.timeout = window.setTimeout(function () {
                p();
              }, u.waitTimeMillis) : t(new h(n, s, e));
            },
                p = function p() {
              n.verbose("RetryingSubscription: trying to re-establish the subscription");
              var e = u({
                onEnd: function onEnd(e) {
                  return t(new c(n, s, e));
                },
                onError: function onError(e) {
                  return f(e);
                },
                onEvent: s.onEvent,
                onOpen: function onOpen(r) {
                  t(new a(n, s, r, e, t));
                },
                onRetrying: s.onRetrying
              }, i);
            };

            f(e);
          }

          return e.prototype.unsubscribe = function () {
            window.clearTimeout(this.timeout), this.onTransition(new c(this.logger, this.listeners));
          }, e;
        }(),
            a = function () {
          function e(e, t, n, r, o) {
            this.logger = e, this.listeners = t, this.headers = n, this.underlyingSubscription = r, this.onTransition = o, e.verbose("RetryingSubscription: transitioning to OpenSubscriptionState"), t.onOpen(n);
          }

          return e.prototype.unsubscribe = function () {
            this.underlyingSubscription.unsubscribe(), this.onTransition(new c(this.logger, this.listeners));
          }, e;
        }(),
            c = function () {
          function e(e, t, n) {
            this.logger = e, this.listeners = t, e.verbose("RetryingSubscription: transitioning to EndedSubscriptionState"), t.onEnd(n);
          }

          return e.prototype.unsubscribe = function () {
            throw new Error("Subscription has already ended");
          }, e;
        }(),
            h = function () {
          function e(e, t, n) {
            this.logger = e, this.listeners = t, e.verbose("RetryingSubscription: transitioning to FailedSubscriptionState", n), t.onError(n);
          }

          return e.prototype.unsubscribe = function () {
            throw new Error("Subscription has already ended");
          }, e;
        }();
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(0);

        t.createTokenProvidingStrategy = function (e, t, n) {
          return n ? function (r, i) {
            return new o(t, r, i, n, e);
          } : e;
        };

        var o = function () {
          function e(e, t, n, r, o) {
            var u = this;
            this.logger = e, this.listeners = t, this.headers = n, this.tokenProvider = r, this.nextSubscribeStrategy = o, this.unsubscribe = function () {
              u.state.unsubscribe(), u.state = new s(u.logger);
            }, this.state = new i(e, n, o), this.subscribe();
          }

          return e.prototype.subscribe = function () {
            var e = this;
            this.tokenProvider.fetchToken().then(function (t) {
              var n = Object.assign({}, e.listeners);
              e.state.subscribe(t, {
                onEnd: function onEnd(t) {
                  e.state = new s(e.logger), n.onEnd(t);
                },
                onError: function onError(r) {
                  e.isTokenExpiredError(r) ? (e.tokenProvider.clearToken(t), e.subscribe()) : (e.state = new s(e.logger), n.onError(r));
                },
                onEvent: e.listeners.onEvent,
                onOpen: e.listeners.onOpen
              });
            }).catch(function (t) {
              e.logger.debug("TokenProvidingSubscription: error when fetching token:", t), e.state = new s(e.logger), e.listeners.onError(t);
            });
          }, e.prototype.isTokenExpiredError = function (e) {
            return e instanceof r.ErrorResponse && 401 === e.statusCode && "authentication/expired" === e.info;
          }, e;
        }(),
            i = function () {
          function e(e, t, n) {
            this.logger = e, this.headers = t, this.nextSubscribeStrategy = n, e.verbose("TokenProvidingSubscription: transitioning to ActiveState");
          }

          return e.prototype.subscribe = function (e, t) {
            var n = this;
            this.putTokenIntoHeader(e), this.underlyingSubscription = this.nextSubscribeStrategy({
              onEnd: function onEnd(e) {
                n.logger.verbose("TokenProvidingSubscription: subscription ended"), t.onEnd(e);
              },
              onError: function onError(e) {
                n.logger.verbose("TokenProvidingSubscription: subscription errored:", e), t.onError(e);
              },
              onEvent: t.onEvent,
              onOpen: function onOpen(e) {
                n.logger.verbose("TokenProvidingSubscription: subscription opened"), t.onOpen(e);
              },
              onRetrying: t.onRetrying
            }, this.headers);
          }, e.prototype.unsubscribe = function () {
            this.underlyingSubscription.unsubscribe();
          }, e.prototype.putTokenIntoHeader = function (e) {
            this.headers.Authorization = "Bearer " + e, this.logger.verbose("TokenProvidingSubscription: token fetched: " + e);
          }, e;
        }(),
            s = function () {
          function e(e) {
            this.logger = e, e.verbose("TokenProvidingSubscription: transitioning to InactiveState");
          }

          return e.prototype.subscribe = function (e, t) {
            this.logger.verbose("TokenProvidingSubscription: subscribe called in Inactive state; doing nothing");
          }, e.prototype.unsubscribe = function () {
            this.logger.verbose("TokenProvidingSubscription: unsubscribe called in Inactive state; doing nothing");
          }, e;
        }();
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createTransportStrategy = function (e, t, n) {
          return function (n, r) {
            return t.subscribe(e, n, r);
          };
        };
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.HOST_BASE = "pusherplatform.io";
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = n(3);
        t.BaseClient = r.BaseClient;
        var o = n(9);
        t.HOST_BASE = o.HOST_BASE;
        var i = n(15);
        t.Instance = i.default;
        var s = n(1);
        t.ConsoleLogger = s.ConsoleLogger, t.EmptyLogger = s.EmptyLogger;
        var u = n(0);
        t.ErrorResponse = u.ErrorResponse, t.NetworkError = u.NetworkError, t.responseToHeadersObject = u.responseToHeadersObject, t.XhrReadyState = u.XhrReadyState;
        var a = n(4);
        t.executeNetworkRequest = a.executeNetworkRequest, t.sendRawRequest = a.sendRawRequest;
        var c = n(5);
        t.createResumingStrategy = c.createResumingStrategy;
        var h = n(2);
        t.createRetryStrategyOptionsOrDefault = h.createRetryStrategyOptionsOrDefault, t.DoNotRetry = h.DoNotRetry, t.Retry = h.Retry, t.RetryResolution = h.RetryResolution;
        var l = n(6);
        t.createRetryingStrategy = l.createRetryingStrategy;
        var d = n(7);
        t.createTokenProvidingStrategy = d.createTokenProvidingStrategy;
        var f = n(8);
        t.createTransportStrategy = f.createTransportStrategy, t.default = {
          BaseClient: r.BaseClient,
          ConsoleLogger: s.ConsoleLogger,
          EmptyLogger: s.EmptyLogger,
          Instance: i.default
        };
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.subscribeStrategyListenersFromSubscriptionListeners = function (e) {
          return {
            onEnd: e.onEnd,
            onError: e.onError,
            onEvent: e.onEvent,
            onOpen: e.onOpen,
            onRetrying: e.onRetrying
          };
        };
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.replaceMissingListenersWithNoOps = function (e) {
          return {
            onEnd: e.onEnd || function (e) {},
            onError: e.onError || function (e) {},
            onEvent: e.onEvent || function (e) {},
            onOpen: e.onOpen || function (e) {},
            onRetrying: e.onRetrying || function () {},
            onSubscribe: e.onSubscribe || function () {}
          };
        };
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r,
            o = n(0);
        !function (e) {
          e[e.UNOPENED = 0] = "UNOPENED", e[e.OPENING = 1] = "OPENING", e[e.OPEN = 2] = "OPEN", e[e.ENDING = 3] = "ENDING", e[e.ENDED = 4] = "ENDED";
        }(r = t.HttpTransportState || (t.HttpTransportState = {}));

        var i = function () {
          function e(e, t) {
            var n = this;
            return this.gotEOS = !1, this.lastNewlineIndex = 0, this.state = r.UNOPENED, this.xhr = e, this.listeners = t, this.xhr.onreadystatechange = function () {
              switch (n.xhr.readyState) {
                case o.XhrReadyState.UNSENT:
                case o.XhrReadyState.OPENED:
                case o.XhrReadyState.HEADERS_RECEIVED:
                  n.assertStateIsIn(r.OPENING);
                  break;

                case o.XhrReadyState.LOADING:
                  n.onLoading();
                  break;

                case o.XhrReadyState.DONE:
                  n.onDone();
              }
            }, this.state = r.OPENING, this.xhr.send(), this;
          }

          return e.prototype.unsubscribe = function () {
            this.state = r.ENDED, this.xhr.abort(), this.listeners.onEnd && this.listeners.onEnd(null);
          }, e.prototype.onLoading = function () {
            if (this.assertStateIsIn(r.OPENING, r.OPEN, r.ENDING), 200 === this.xhr.status) {
              this.state === r.OPENING && (this.state = r.OPEN, window.console.log(o.responseToHeadersObject(this.xhr.getAllResponseHeaders())), this.listeners.onOpen && this.listeners.onOpen(o.responseToHeadersObject(this.xhr.getAllResponseHeaders()))), this.assertStateIsIn(r.OPEN);
              var e = this.onChunk();
              this.assertStateIsIn(r.OPEN, r.ENDING), e && (this.state = r.ENDED, e instanceof o.ErrorResponse && 204 !== e.statusCode && this.listeners.onError && this.listeners.onError(e));
            }
          }, e.prototype.onDone = function () {
            if (200 === this.xhr.status) {
              this.state === r.OPENING && (this.state = r.OPEN, this.listeners.onOpen && this.listeners.onOpen(o.responseToHeadersObject(this.xhr.getAllResponseHeaders()))), this.assertStateIsIn(r.OPEN, r.ENDING);
              var e = this.onChunk();
              e ? (this.state = r.ENDED, 204 === e.statusCode ? this.listeners.onEnd && this.listeners.onEnd(null) : this.listeners.onError && this.listeners.onError(e)) : this.state <= r.ENDING ? this.listeners.onError && this.listeners.onError(new Error("HTTP response ended without receiving EOS message")) : this.listeners.onEnd && this.listeners.onEnd(null);
            } else {
              if (this.assertStateIsIn(r.OPENING, r.OPEN, r.ENDED), this.state === r.ENDED) return;
              0 === this.xhr.status ? this.listeners.onError && this.listeners.onError(new o.NetworkError("Connection lost.")) : this.listeners.onError && this.listeners.onError(o.ErrorResponse.fromXHR(this.xhr));
            }
          }, e.prototype.onChunk = function () {
            this.assertStateIsIn(r.OPEN);
            var e = this.xhr.responseText,
                t = e.lastIndexOf("\n");

            if (t > this.lastNewlineIndex) {
              var n = e.slice(this.lastNewlineIndex, t).split("\n");
              this.lastNewlineIndex = t;

              for (var o = 0, i = n; o < i.length; o++) {
                var s = i[o];

                if (0 !== s.length) {
                  var u = JSON.parse(s),
                      a = this.onMessage(u);
                  if (null != a) return a;
                }
              }
            }
          }, e.prototype.assertStateIsIn = function () {
            for (var e = this, t = [], n = 0; n < arguments.length; n++) {
              t[n] = arguments[n];
            }

            if (!t.some(function (t) {
              return t === e.state;
            })) {
              var o = t.map(function (e) {
                return r[e];
              }).join(", "),
                  i = r[this.state];
              window.console.warn("Expected this.state to be one of [" + o + "] but it is " + i);
            }
          }, e.prototype.onMessage = function (e) {
            switch (this.assertStateIsIn(r.OPEN), this.verifyMessage(e), e[0]) {
              case 0:
                return null;

              case 1:
                return this.onEventMessage(e);

              case 255:
                return this.onEOSMessage(e);

              default:
                return new Error("Unknown Message: " + JSON.stringify(e));
            }
          }, e.prototype.onEventMessage = function (e) {
            if (this.assertStateIsIn(r.OPEN), 4 !== e.length) return new Error("Event message has " + e.length + " elements (expected 4)");
            e[0];
            var t = e[1],
                n = e[2],
                o = e[3];
            return "string" != typeof t ? new Error("Invalid event ID in message: " + JSON.stringify(e)) : "object" != typeof n || Array.isArray(n) ? new Error("Invalid event headers in message: " + JSON.stringify(e)) : (this.listeners.onEvent && this.listeners.onEvent({
              body: o,
              headers: n,
              eventId: t
            }), null);
          }, e.prototype.onEOSMessage = function (e) {
            if (this.assertStateIsIn(r.OPEN), 4 !== e.length) return new Error("EOS message has " + e.length + " elements (expected 4)");
            e[0];
            var t = e[1],
                n = e[2],
                i = e[3];
            return "number" != typeof t ? new Error("Invalid EOS Status Code") : "object" != typeof n || Array.isArray(n) ? new Error("Invalid EOS ElementsHeaders") : (this.state = r.ENDING, new o.ErrorResponse(t, n, i));
          }, e.prototype.verifyMessage = function (e) {
            return this.gotEOS ? new Error("Got another message after EOS message") : Array.isArray(e) ? e.length < 1 ? new Error("Message is empty array") : void 0 : new Error("Message is not an array");
          }, e;
        }(),
            s = function () {
          function e(e, t) {
            void 0 === t && (t = !0), this.baseURL = (t ? "https" : "http") + "://" + e;
          }

          return e.prototype.request = function (e) {
            return this.createXHR(this.baseURL, e);
          }, e.prototype.subscribe = function (e, t, n) {
            var r = {
              headers: n,
              method: "SUBSCRIBE",
              path: e
            };
            return new i(this.createXHR(this.baseURL, r), t);
          }, e.prototype.createXHR = function (e, t) {
            var n = new window.XMLHttpRequest(),
                r = e + "/" + t.path.replace(/^\/+/, "");
            if (n.open(t.method.toUpperCase(), r, !0), n = this.setJSONHeaderIfAppropriate(n, t), t.jwt && n.setRequestHeader("authorization", "Bearer " + t.jwt), t.headers) for (var o in t.headers) {
              t.headers.hasOwnProperty(o) && n.setRequestHeader(o, t.headers[o]);
            }
            return n;
          }, e.prototype.setJSONHeaderIfAppropriate = function (e, t) {
            return t.json && e.setRequestHeader("content-type", "application/json"), e;
          }, e;
        }();

        t.default = s;
      }, function (e, t, n) {
        var r = this && this.__assign || Object.assign || function (e) {
          for (var t, n = 1, r = arguments.length; n < r; n++) {
            for (var o in t = arguments[n]) {
              Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            }
          }

          return e;
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o,
            i = n(0);
        !function (e) {
          e[e.Connecting = 0] = "Connecting", e[e.Open = 1] = "Open", e[e.Closing = 2] = "Closing", e[e.Closed = 3] = "Closed";
        }(o = t.WSReadyState || (t.WSReadyState = {}));

        var s = function () {
          function e() {
            this.subscriptions = {};
          }

          return e.prototype.add = function (e, t, n, r) {
            return this.subscriptions[e] = {
              headers: r,
              listeners: n,
              path: t
            }, e;
          }, e.prototype.has = function (e) {
            return void 0 !== this.subscriptions[e];
          }, e.prototype.isEmpty = function () {
            return 0 === Object.keys(this.subscriptions).length;
          }, e.prototype.remove = function (e) {
            return delete this.subscriptions[e];
          }, e.prototype.get = function (e) {
            return this.subscriptions[e];
          }, e.prototype.getAll = function () {
            return this.subscriptions;
          }, e.prototype.getAllAsArray = function () {
            var e = this;
            return Object.keys(this.subscriptions).map(function (t) {
              return r({
                subID: parseInt(t, 10)
              }, e.subscriptions[parseInt(t, 10)]);
            });
          }, e.prototype.removeAll = function () {
            this.subscriptions = {};
          }, e;
        }(),
            u = function () {
          function e(e, t) {
            this.wsTransport = e, this.subID = t;
          }

          return e.prototype.unsubscribe = function () {
            this.wsTransport.unsubscribe(this.subID);
          }, e;
        }(),
            a = function () {
          function e(e) {
            this.webSocketPath = "/ws", this.forcedClose = !1, this.closedError = null, this.baseURL = "wss://" + e + this.webSocketPath, this.lastSubscriptionID = 0, this.subscriptions = new s(), this.pendingSubscriptions = new s(), this.connect();
          }

          return e.prototype.subscribe = function (e, t, n) {
            this.tryReconnectIfNeeded();
            var r = this.lastSubscriptionID++;
            return this.socket.readyState !== o.Open ? (this.pendingSubscriptions.add(r, e, t, n), new u(this, r)) : (this.subscriptions.add(r, e, t, n), this.sendMessage(this.getMessage(100, r, e, n)), new u(this, r));
          }, e.prototype.unsubscribe = function (e) {
            this.sendMessage(this.getMessage(198, e));
            var t = this.subscriptions.get(e);
            t.listeners.onEnd && t.listeners.onEnd(null), this.subscriptions.remove(e);
          }, e.prototype.connect = function () {
            var e = this;
            this.forcedClose = !1, this.closedError = null, this.socket = new window.WebSocket(this.baseURL), this.socket.onopen = function (t) {
              e.pendingSubscriptions.getAllAsArray().forEach(function (t) {
                var n = t.subID,
                    r = t.path,
                    o = t.listeners,
                    i = t.headers;
                e.subscribePending(r, o, i, n);
              }), e.pendingSubscriptions.removeAll(), e.pingInterval = window.setInterval(function () {
                if (!e.pongTimeout) {
                  var t = new Date().getTime();
                  1e4 > t - e.lastMessageReceivedTimestamp || (e.sendMessage(e.getMessage(16, t)), e.lastSentPingID = t, e.pongTimeout = window.setTimeout(function () {
                    1e4 > new Date().getTime() - e.lastMessageReceivedTimestamp ? e.pongTimeout = null : e.close(new i.NetworkError("Pong response wasn't received until timeout."));
                  }, 1e4));
                }
              }, 3e4);
            }, this.socket.onmessage = function (t) {
              return e.receiveMessage(t);
            }, this.socket.onerror = function (t) {
              e.close(new i.NetworkError("Connection was lost."));
            }, this.socket.onclose = function (t) {
              if (e.forcedClose) {
                var n = e.closedError ? function (t) {
                  t.listeners.onError && t.listeners.onError(e.closedError);
                } : function (e) {
                  e.listeners.onEnd && e.listeners.onEnd(null);
                },
                    r = !1 === e.pendingSubscriptions.isEmpty() ? e.pendingSubscriptions : e.subscriptions;
                r.getAllAsArray().forEach(n), r.removeAll(), e.closedError && e.tryReconnectIfNeeded();
              } else e.tryReconnectIfNeeded();
            };
          }, e.prototype.close = function (e) {
            if (this.socket instanceof window.WebSocket) {
              var t = this.socket.onclose.bind(this);
              delete this.socket.onclose, delete this.socket.onerror, delete this.socket.onmessage, delete this.socket.onopen, this.forcedClose = !0, this.closedError = e, this.socket.close(), window.clearTimeout(this.pingInterval), window.clearTimeout(this.pongTimeout), delete this.pongTimeout, this.lastSentPingID = null, t();
            }
          }, e.prototype.tryReconnectIfNeeded = function () {
            (this.forcedClose || this.socket.readyState === o.Closed) && this.connect();
          }, e.prototype.subscribePending = function (e, t, n, r) {
            void 0 !== r ? (this.subscriptions.add(r, e, t, n), this.sendMessage(this.getMessage(100, r, e, n))) : window.console.log("Subscription to path " + e + " has an undefined ID");
          }, e.prototype.getMessage = function (e, t, n, r) {
            return [e, t, n, r];
          }, e.prototype.sendMessage = function (e) {
            if (this.socket.readyState !== o.Open) return window.console.warn("Can't send in \"" + o[this.socket.readyState] + '" state');
            this.socket.send(JSON.stringify(e));
          }, e.prototype.subscription = function (e) {
            return this.subscriptions.get(e);
          }, e.prototype.receiveMessage = function (e) {
            var t;
            this.lastMessageReceivedTimestamp = new Date().getTime();

            try {
              t = JSON.parse(e.data);
            } catch (t) {
              return void this.close(new Error("Message is not valid JSON format. Getting " + e.data));
            }

            var n = this.validateMessage(t);
            if (n) this.close(new Error(n.message));else {
              var r = t.shift();

              switch (r) {
                case 17:
                  return void this.onPongMessage(t);

                case 16:
                  return void this.onPingMessage(t);

                case 99:
                  return void this.onCloseMessage(t);
              }

              var o = t.shift(),
                  i = this.subscription(o);

              if (i) {
                var s = i.listeners;

                switch (r) {
                  case 101:
                    this.onOpenMessage(t, o, s);
                    break;

                  case 102:
                    this.onEventMessage(t, s);
                    break;

                  case 199:
                    this.onEOSMessage(t, o, s);
                    break;

                  default:
                    this.close(new Error("Received non existing type of message."));
                }
              } else this.close(new Error('Received message for non existing subscription id: "' + o + '"'));
            }
          }, e.prototype.validateMessage = function (e) {
            return Array.isArray(e) ? e.length < 1 ? new Error("Message is empty array: " + JSON.stringify(e)) : null : new Error("Message is expected to be an array. Getting: " + JSON.stringify(e));
          }, e.prototype.onOpenMessage = function (e, t, n) {
            n.onOpen && n.onOpen(e[1]);
          }, e.prototype.onEventMessage = function (e, t) {
            if (3 !== e.length) return new Error("Event message has " + e.length + " elements (expected 4)");
            var n = e[0],
                r = e[1],
                o = e[2];
            return "string" != typeof n ? new Error("Invalid event ID in message: " + JSON.stringify(e)) : "object" != typeof r || Array.isArray(r) ? new Error("Invalid event headers in message: " + JSON.stringify(e)) : void (t.onEvent && t.onEvent({
              eventId: n,
              headers: r,
              body: o
            }));
          }, e.prototype.onEOSMessage = function (e, t, n) {
            if (this.subscriptions.remove(t), 3 === e.length) {
              var r = e[0],
                  o = e[1],
                  s = e[2];
              "number" == typeof r ? "object" != typeof o || Array.isArray(o) ? n.onError && n.onError(new Error("Invalid EOS ElementsHeaders")) : 204 !== r ? n.onError && n.onError(new i.ErrorResponse(r, o, s)) : n.onEnd && n.onEnd(null) : n.onError && n.onError(new Error("Invalid EOS Status Code"));
            } else n.onError && n.onError(new Error("EOS message has " + e.length + " elements (expected 4)"));
          }, e.prototype.onCloseMessage = function (e) {
            var t = e[0],
                n = e[1];
            e[2];
            return "number" != typeof t ? this.close(new Error("Close message: Invalid EOS Status Code")) : "object" != typeof n || Array.isArray(n) ? this.close(new Error("Close message: Invalid EOS ElementsHeaders")) : void this.close();
          }, e.prototype.onPongMessage = function (e) {
            var t = e[0];
            this.lastSentPingID !== t && window.console.warn("Received pong with ID " + t + " but lastSentPingID was " + this.lastSentPingID), window.clearTimeout(this.pongTimeout), delete this.pongTimeout, this.lastSentPingID = null;
          }, e.prototype.onPingMessage = function (e) {
            var t = e[0];
            this.sendMessage(this.getMessage(17, t));
          }, e;
        }();

        t.default = a;
      }, function (e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });

        var r = n(3),
            o = n(9),
            i = n(1),
            s = function () {
          function e(e) {
            if (!e.locator) throw new Error("Expected `locator` property in Instance options!");
            var t = e.locator.split(":");
            if (3 !== t.length) throw new Error("The instance locator supplied is invalid. Did you copy it correctly from the Pusher dashboard?");
            if (!e.serviceName) throw new Error("Expected `serviceName` property in Instance options!");
            if (!e.serviceVersion) throw new Error("Expected `serviceVersion` property in Instance options!");
            this.platformVersion = t[0], this.cluster = t[1], this.id = t[2], this.serviceName = e.serviceName, this.serviceVersion = e.serviceVersion, this.host = e.host || this.cluster + "." + o.HOST_BASE, this.logger = e.logger || new i.ConsoleLogger(), this.client = e.client || new r.BaseClient({
              encrypted: e.encrypted,
              host: this.host,
              logger: this.logger
            }), this.tokenProvider = e.tokenProvider;
          }

          return e.prototype.request = function (e, t) {
            return e.path = this.absPath(e.path), null != e.headers && void 0 !== e.headers || (e.headers = {}), e.tokenProvider = e.tokenProvider || this.tokenProvider, this.client.request(e, t);
          }, e.prototype.subscribeNonResuming = function (e) {
            var t = e.headers || {},
                n = e.retryStrategyOptions || {},
                r = e.tokenProvider || this.tokenProvider;
            return this.client.subscribeNonResuming(this.absPath(e.path), t, e.listeners, n, r);
          }, e.prototype.subscribeResuming = function (e) {
            var t = e.headers || {},
                n = e.retryStrategyOptions || {},
                r = e.tokenProvider || this.tokenProvider;
            return this.client.subscribeResuming(this.absPath(e.path), t, e.listeners, n, e.initialEventId, r);
          }, e.prototype.absPath = function (e) {
            return ("/services/" + this.serviceName + "/" + this.serviceVersion + "/" + this.id + "/" + e).replace(/\/+/g, "/").replace(/\/+$/, "");
          }, e;
        }();

        t.default = s;
      }]);
    }, e.exports = n();
  }(e = {
    exports: {}
  }, e.exports), e.exports);
  (t = n) && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") && t.default;
  var r = n.BaseClient,
      o = n.HOST_BASE,
      i = n.Instance,
      s = n.sendRawRequest;

  function u(e) {
    return null != e && "object" == typeof e && !0 === e["@@functional/placeholder"];
  }

  function a(e) {
    return function t(n) {
      return 0 === arguments.length || u(n) ? t : e.apply(this, arguments);
    };
  }

  function c(e) {
    return function t(n, r) {
      switch (arguments.length) {
        case 0:
          return t;

        case 1:
          return u(n) ? t : a(function (t) {
            return e(n, t);
          });

        default:
          return u(n) && u(r) ? t : u(n) ? a(function (t) {
            return e(t, r);
          }) : u(r) ? a(function (t) {
            return e(n, t);
          }) : e(n, r);
      }
    };
  }

  function h(e, t) {
    var n;
    e = e || [], t = t || [];
    var r = e.length,
        o = t.length,
        i = [];

    for (n = 0; n < r;) {
      i[i.length] = e[n], n += 1;
    }

    for (n = 0; n < o;) {
      i[i.length] = t[n], n += 1;
    }

    return i;
  }

  function l(e, t) {
    switch (e) {
      case 0:
        return function () {
          return t.apply(this, arguments);
        };

      case 1:
        return function (e) {
          return t.apply(this, arguments);
        };

      case 2:
        return function (e, n) {
          return t.apply(this, arguments);
        };

      case 3:
        return function (e, n, r) {
          return t.apply(this, arguments);
        };

      case 4:
        return function (e, n, r, o) {
          return t.apply(this, arguments);
        };

      case 5:
        return function (e, n, r, o, i) {
          return t.apply(this, arguments);
        };

      case 6:
        return function (e, n, r, o, i, s) {
          return t.apply(this, arguments);
        };

      case 7:
        return function (e, n, r, o, i, s, u) {
          return t.apply(this, arguments);
        };

      case 8:
        return function (e, n, r, o, i, s, u, a) {
          return t.apply(this, arguments);
        };

      case 9:
        return function (e, n, r, o, i, s, u, a, c) {
          return t.apply(this, arguments);
        };

      case 10:
        return function (e, n, r, o, i, s, u, a, c, h) {
          return t.apply(this, arguments);
        };

      default:
        throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
    }
  }

  function d(e, t, n) {
    return function () {
      for (var r = [], o = 0, i = e, s = 0; s < t.length || o < arguments.length;) {
        var a;
        s < t.length && (!u(t[s]) || o >= arguments.length) ? a = t[s] : (a = arguments[o], o += 1), r[s] = a, u(a) || (i -= 1), s += 1;
      }

      return i <= 0 ? n.apply(this, r) : l(i, d(e, r, n));
    };
  }

  var f = c(function (e, t) {
    return 1 === e ? a(t) : l(e, d(e, [], t));
  });

  function p(e) {
    return function t(n, r, o) {
      switch (arguments.length) {
        case 0:
          return t;

        case 1:
          return u(n) ? t : c(function (t, r) {
            return e(n, t, r);
          });

        case 2:
          return u(n) && u(r) ? t : u(n) ? c(function (t, n) {
            return e(t, r, n);
          }) : u(r) ? c(function (t, r) {
            return e(n, t, r);
          }) : a(function (t) {
            return e(n, r, t);
          });

        default:
          return u(n) && u(r) && u(o) ? t : u(n) && u(r) ? c(function (t, n) {
            return e(t, n, o);
          }) : u(n) && u(o) ? c(function (t, n) {
            return e(t, r, n);
          }) : u(r) && u(o) ? c(function (t, r) {
            return e(n, t, r);
          }) : u(n) ? a(function (t) {
            return e(t, r, o);
          }) : u(r) ? a(function (t) {
            return e(n, t, o);
          }) : u(o) ? a(function (t) {
            return e(n, r, t);
          }) : e(n, r, o);
      }
    };
  }

  var g = Array.isArray || function (e) {
    return null != e && e.length >= 0 && "[object Array]" === Object.prototype.toString.call(e);
  };

  function m(e, t, n) {
    return function () {
      if (0 === arguments.length) return n();
      var r = Array.prototype.slice.call(arguments, 0),
          o = r.pop();

      if (!g(o)) {
        for (var i = 0; i < e.length;) {
          if ("function" == typeof o[e[i]]) return o[e[i]].apply(o, r);
          i += 1;
        }

        if (function (e) {
          return "function" == typeof e["@@transducer/step"];
        }(o)) return t.apply(null, r)(o);
      }

      return n.apply(this, arguments);
    };
  }

  var b = {
    init: function init() {
      return this.xf["@@transducer/init"]();
    },
    result: function result(e) {
      return this.xf["@@transducer/result"](e);
    }
  },
      v = c(function (e, t) {
    return t > e ? t : e;
  });

  function y(e, t) {
    for (var n = 0, r = t.length, o = Array(r); n < r;) {
      o[n] = e(t[n]), n += 1;
    }

    return o;
  }

  function S(e) {
    return "[object String]" === Object.prototype.toString.call(e);
  }

  var w = a(function (e) {
    return !!g(e) || !!e && "object" == typeof e && !S(e) && (1 === e.nodeType ? !!e.length : 0 === e.length || e.length > 0 && e.hasOwnProperty(0) && e.hasOwnProperty(e.length - 1));
  }),
      E = function () {
    function e(e) {
      this.f = e;
    }

    return e.prototype["@@transducer/init"] = function () {
      throw new Error("init not implemented on XWrap");
    }, e.prototype["@@transducer/result"] = function (e) {
      return e;
    }, e.prototype["@@transducer/step"] = function (e, t) {
      return this.f(e, t);
    }, e;
  }();

  function I(e) {
    return new E(e);
  }

  var k = c(function (e, t) {
    return l(e.length, function () {
      return e.apply(t, arguments);
    });
  });

  function R(e, t, n) {
    for (var r = n.next(); !r.done;) {
      if ((t = e["@@transducer/step"](t, r.value)) && t["@@transducer/reduced"]) {
        t = t["@@transducer/value"];
        break;
      }

      r = n.next();
    }

    return e["@@transducer/result"](t);
  }

  function T(e, t, n, r) {
    return e["@@transducer/result"](n[r](k(e["@@transducer/step"], e), t));
  }

  var O = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator";

  function P(e, t, n) {
    if ("function" == typeof e && (e = I(e)), w(n)) return function (e, t, n) {
      for (var r = 0, o = n.length; r < o;) {
        if ((t = e["@@transducer/step"](t, n[r])) && t["@@transducer/reduced"]) {
          t = t["@@transducer/value"];
          break;
        }

        r += 1;
      }

      return e["@@transducer/result"](t);
    }(e, t, n);
    if ("function" == typeof n["fantasy-land/reduce"]) return T(e, t, n, "fantasy-land/reduce");
    if (null != n[O]) return R(e, t, n[O]());
    if ("function" == typeof n.next) return R(e, t, n);
    if ("function" == typeof n.reduce) return T(e, t, n, "reduce");
    throw new TypeError("reduce: list must be array or iterable");
  }

  var N = function () {
    function e(e, t) {
      this.xf = t, this.f = e;
    }

    return e.prototype["@@transducer/init"] = b.init, e.prototype["@@transducer/result"] = b.result, e.prototype["@@transducer/step"] = function (e, t) {
      return this.xf["@@transducer/step"](e, this.f(t));
    }, e;
  }(),
      U = c(function (e, t) {
    return new N(e, t);
  });

  function _(e, t) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }

  var C = Object.prototype.toString,
      A = function A() {
    return "[object Arguments]" === C.call(arguments) ? function (e) {
      return "[object Arguments]" === C.call(e);
    } : function (e) {
      return _("callee", e);
    };
  },
      M = !{
    toString: null
  }.propertyIsEnumerable("toString"),
      j = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"],
      D = function () {
    return arguments.propertyIsEnumerable("length");
  }(),
      x = function x(e, t) {
    for (var n = 0; n < e.length;) {
      if (e[n] === t) return !0;
      n += 1;
    }

    return !1;
  },
      q = a("function" != typeof Object.keys || D ? function (e) {
    if (Object(e) !== e) return [];
    var t,
        n,
        r = [],
        o = D && A(e);

    for (t in e) {
      !_(t, e) || o && "length" === t || (r[r.length] = t);
    }

    if (M) for (n = j.length - 1; n >= 0;) {
      _(t = j[n], e) && !x(r, t) && (r[r.length] = t), n -= 1;
    }
    return r;
  } : function (e) {
    return Object(e) !== e ? [] : Object.keys(e);
  }),
      B = c(m(["fantasy-land/map", "map"], U, function (e, t) {
    switch (Object.prototype.toString.call(t)) {
      case "[object Function]":
        return f(t.length, function () {
          return e.call(this, t.apply(this, arguments));
        });

      case "[object Object]":
        return P(function (n, r) {
          return n[r] = e(t[r]), n;
        }, {}, q(t));

      default:
        return y(e, t);
    }
  })),
      L = c(function (e, t) {
    for (var n = t, r = 0; r < e.length;) {
      if (null == n) return;
      n = n[e[r]], r += 1;
    }

    return n;
  }),
      H = c(function (e, t) {
    return L([e], t);
  }),
      F = p(P),
      G = c(function (e, t) {
    return h(t, [e]);
  }),
      J = a(function (e) {
    for (var t = q(e), n = t.length, r = [], o = 0; o < n;) {
      r[o] = e[t[o]], o += 1;
    }

    return r;
  });

  var z = a(function (e) {
    return null === e ? "Null" : void 0 === e ? "Undefined" : Object.prototype.toString.call(e).slice(8, -1);
  });

  function X(e, t) {
    return function () {
      return t.call(this, e.apply(this, arguments));
    };
  }

  function V(e, t) {
    return function () {
      var n = arguments.length;
      if (0 === n) return t();
      var r = arguments[n - 1];
      return g(r) || "function" != typeof r[e] ? t.apply(this, arguments) : r[e].apply(r, Array.prototype.slice.call(arguments, 0, n - 1));
    };
  }

  var W = p(V("slice", function (e, t, n) {
    return Array.prototype.slice.call(n, e, t);
  })),
      K = a(V("tail", W(1, 1 / 0)));

  function $() {
    if (0 === arguments.length) throw new Error("pipe requires at least one argument");
    return l(arguments[0].length, F(X, arguments[0], K(arguments)));
  }

  var Y = a(function (e) {
    return S(e) ? e.split("").reverse().join("") : Array.prototype.slice.call(e, 0).reverse();
  });

  function Z() {
    if (0 === arguments.length) throw new Error("compose requires at least one argument");
    return $.apply(this, Y(arguments));
  }

  function Q(e) {
    for (var t, n = []; !(t = e.next()).done;) {
      n.push(t.value);
    }

    return n;
  }

  function ee(e, t, n) {
    for (var r = 0, o = n.length; r < o;) {
      if (e(t, n[r])) return !0;
      r += 1;
    }

    return !1;
  }

  var te = c(function (e, t) {
    return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
  });

  function ne(e, t, n, r) {
    var o = Q(e);

    function i(e, t) {
      return re(e, t, n.slice(), r.slice());
    }

    return !ee(function (e, t) {
      return !ee(i, t, e);
    }, Q(t), o);
  }

  function re(e, t, n, r) {
    if (te(e, t)) return !0;
    var o,
        i,
        s = z(e);
    if (s !== z(t)) return !1;
    if (null == e || null == t) return !1;
    if ("function" == typeof e["fantasy-land/equals"] || "function" == typeof t["fantasy-land/equals"]) return "function" == typeof e["fantasy-land/equals"] && e["fantasy-land/equals"](t) && "function" == typeof t["fantasy-land/equals"] && t["fantasy-land/equals"](e);
    if ("function" == typeof e.equals || "function" == typeof t.equals) return "function" == typeof e.equals && e.equals(t) && "function" == typeof t.equals && t.equals(e);

    switch (s) {
      case "Arguments":
      case "Array":
      case "Object":
        if ("function" == typeof e.constructor && "Promise" === (o = e.constructor, null == (i = String(o).match(/^function (\w*)/)) ? "" : i[1])) return e === t;
        break;

      case "Boolean":
      case "Number":
      case "String":
        if (typeof e != typeof t || !te(e.valueOf(), t.valueOf())) return !1;
        break;

      case "Date":
        if (!te(e.valueOf(), t.valueOf())) return !1;
        break;

      case "Error":
        return e.name === t.name && e.message === t.message;

      case "RegExp":
        if (e.source !== t.source || e.global !== t.global || e.ignoreCase !== t.ignoreCase || e.multiline !== t.multiline || e.sticky !== t.sticky || e.unicode !== t.unicode) return !1;
    }

    for (var u = n.length - 1; u >= 0;) {
      if (n[u] === e) return r[u] === t;
      u -= 1;
    }

    switch (s) {
      case "Map":
        return e.size === t.size && ne(e.entries(), t.entries(), n.concat([e]), r.concat([t]));

      case "Set":
        return e.size === t.size && ne(e.values(), t.values(), n.concat([e]), r.concat([t]));

      case "Arguments":
      case "Array":
      case "Object":
      case "Boolean":
      case "Number":
      case "String":
      case "Date":
      case "Error":
      case "RegExp":
      case "Int8Array":
      case "Uint8Array":
      case "Uint8ClampedArray":
      case "Int16Array":
      case "Uint16Array":
      case "Int32Array":
      case "Uint32Array":
      case "Float32Array":
      case "Float64Array":
      case "ArrayBuffer":
        break;

      default:
        return !1;
    }

    var a = q(e);
    if (a.length !== q(t).length) return !1;
    var c = n.concat([e]),
        h = r.concat([t]);

    for (u = a.length - 1; u >= 0;) {
      var l = a[u];
      if (!_(l, t) || !re(t[l], e[l], c, h)) return !1;
      u -= 1;
    }

    return !0;
  }

  var oe = c(function (e, t) {
    return re(e, t, [], []);
  });

  function ie(e, t) {
    return function (e, t, n) {
      var r, o;
      if ("function" == typeof e.indexOf) switch (typeof t) {
        case "number":
          if (0 === t) {
            for (r = 1 / t; n < e.length;) {
              if (0 === (o = e[n]) && 1 / o === r) return n;
              n += 1;
            }

            return -1;
          }

          if (t != t) {
            for (; n < e.length;) {
              if ("number" == typeof (o = e[n]) && o != o) return n;
              n += 1;
            }

            return -1;
          }

          return e.indexOf(t, n);

        case "string":
        case "boolean":
        case "function":
        case "undefined":
          return e.indexOf(t, n);

        case "object":
          if (null === t) return e.indexOf(t, n);
      }

      for (; n < e.length;) {
        if (oe(e[n], t)) return n;
        n += 1;
      }

      return -1;
    }(t, e, 0) >= 0;
  }

  function se(e) {
    return '"' + e.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0").replace(/"/g, '\\"') + '"';
  }

  var ue = function ue(e) {
    return (e < 10 ? "0" : "") + e;
  },
      ae = "function" == typeof Date.prototype.toISOString ? function (e) {
    return e.toISOString();
  } : function (e) {
    return e.getUTCFullYear() + "-" + ue(e.getUTCMonth() + 1) + "-" + ue(e.getUTCDate()) + "T" + ue(e.getUTCHours()) + ":" + ue(e.getUTCMinutes()) + ":" + ue(e.getUTCSeconds()) + "." + (e.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
  };

  function ce(e) {
    return "[object Object]" === Object.prototype.toString.call(e);
  }

  var he = function () {
    function e(e, t) {
      this.xf = t, this.f = e;
    }

    return e.prototype["@@transducer/init"] = b.init, e.prototype["@@transducer/result"] = b.result, e.prototype["@@transducer/step"] = function (e, t) {
      return this.f(t) ? this.xf["@@transducer/step"](e, t) : e;
    }, e;
  }(),
      le = c(m(["filter"], c(function (e, t) {
    return new he(e, t);
  }), function (e, t) {
    return ce(t) ? P(function (n, r) {
      return e(t[r]) && (n[r] = t[r]), n;
    }, {}, q(t)) : function (e, t) {
      for (var n = 0, r = t.length, o = []; n < r;) {
        e(t[n]) && (o[o.length] = t[n]), n += 1;
      }

      return o;
    }(e, t);
  })),
      de = c(function (e, t) {
    return le((n = e, function () {
      return !n.apply(this, arguments);
    }), t);
    var n;
  });

  var fe = a(function (e) {
    return function e(t, n) {
      var r = function r(_r) {
        var o = n.concat([t]);
        return ie(_r, o) ? "<Circular>" : e(_r, o);
      },
          o = function o(e, t) {
        return y(function (t) {
          return se(t) + ": " + r(e[t]);
        }, t.slice().sort());
      };

      switch (Object.prototype.toString.call(t)) {
        case "[object Arguments]":
          return "(function() { return arguments; }(" + y(r, t).join(", ") + "))";

        case "[object Array]":
          return "[" + y(r, t).concat(o(t, de(function (e) {
            return /^\d+$/.test(e);
          }, q(t)))).join(", ") + "]";

        case "[object Boolean]":
          return "object" == typeof t ? "new Boolean(" + r(t.valueOf()) + ")" : t.toString();

        case "[object Date]":
          return "new Date(" + (isNaN(t.valueOf()) ? r(NaN) : se(ae(t))) + ")";

        case "[object Null]":
          return "null";

        case "[object Number]":
          return "object" == typeof t ? "new Number(" + r(t.valueOf()) + ")" : 1 / t == -1 / 0 ? "-0" : t.toString(10);

        case "[object String]":
          return "object" == typeof t ? "new String(" + r(t.valueOf()) + ")" : se(t);

        case "[object Undefined]":
          return "undefined";

        default:
          if ("function" == typeof t.toString) {
            var i = t.toString();
            if ("[object Object]" !== i) return i;
          }

          return "{" + o(t, q(t)).join(", ") + "}";
      }
    }(e, []);
  }),
      pe = c(ie),
      ge = function () {
    function e(e, t, n, r) {
      this.valueFn = e, this.valueAcc = t, this.keyFn = n, this.xf = r, this.inputs = {};
    }

    return e.prototype["@@transducer/init"] = b.init, e.prototype["@@transducer/result"] = function (e) {
      var t;

      for (t in this.inputs) {
        if (_(t, this.inputs) && (e = this.xf["@@transducer/step"](e, this.inputs[t]))["@@transducer/reduced"]) {
          e = e["@@transducer/value"];
          break;
        }
      }

      return this.inputs = null, this.xf["@@transducer/result"](e);
    }, e.prototype["@@transducer/step"] = function (e, t) {
      var n = this.keyFn(t);
      return this.inputs[n] = this.inputs[n] || [n, this.valueAcc], this.inputs[n][1] = this.valueFn(this.inputs[n][1], t), e;
    }, e;
  }(),
      me = d(4, [], m([], d(4, [], function (e, t, n, r) {
    return new ge(e, t, n, r);
  }), function (e, t, n, r) {
    return P(function (r, o) {
      var i = n(o);
      return r[i] = e(_(i, r) ? r[i] : t, o), r;
    }, {}, r);
  })),
      be = c(function (e, t) {
    for (var n = [], r = 0, o = e.length; r < o;) {
      ie(e[r], t) || ie(e[r], n) || (n[n.length] = e[r]), r += 1;
    }

    return n;
  }),
      ve = c(function (e, t) {
    var n = e < 0 ? t.length + e : e;
    return S(t) ? t.charAt(n) : t[n];
  }),
      ye = a(function (e) {
    return null != e && "function" == typeof e["fantasy-land/empty"] ? e["fantasy-land/empty"]() : null != e && null != e.constructor && "function" == typeof e.constructor["fantasy-land/empty"] ? e.constructor["fantasy-land/empty"]() : null != e && "function" == typeof e.empty ? e.empty() : null != e && null != e.constructor && "function" == typeof e.constructor.empty ? e.constructor.empty() : g(e) ? [] : S(e) ? "" : ce(e) ? {} : A(e) ? function () {
      return arguments;
    }() : void 0;
  }),
      Se = c(V("forEach", function (e, t) {
    for (var n = t.length, r = 0; r < n;) {
      e(t[r]), r += 1;
    }

    return t;
  })),
      we = c(function (e, t) {
    for (var n = q(t), r = 0; r < n.length;) {
      var o = n[r];
      e(t[o], o, t), r += 1;
    }

    return t;
  }),
      Ee = c(_),
      Ie = ve(0);

  function ke(e) {
    return e;
  }

  var Re = a(ke),
      Te = me(function (e, t) {
    return t;
  }, null),
      Oe = function () {
    function e() {
      this._nativeSet = "function" == typeof Set ? new Set() : null, this._items = {};
    }

    return e.prototype.add = function (e) {
      return !Pe(e, !0, this);
    }, e.prototype.has = function (e) {
      return Pe(e, !1, this);
    }, e;
  }();

  function Pe(e, t, n) {
    var r,
        o = typeof e;

    switch (o) {
      case "string":
      case "number":
        return 0 === e && 1 / e == -1 / 0 ? !!n._items["-0"] || (t && (n._items["-0"] = !0), !1) : null !== n._nativeSet ? t ? (r = n._nativeSet.size, n._nativeSet.add(e), n._nativeSet.size === r) : n._nativeSet.has(e) : o in n._items ? e in n._items[o] || (t && (n._items[o][e] = !0), !1) : (t && (n._items[o] = {}, n._items[o][e] = !0), !1);

      case "boolean":
        if (o in n._items) {
          var i = e ? 1 : 0;
          return !!n._items[o][i] || (t && (n._items[o][i] = !0), !1);
        }

        return t && (n._items[o] = e ? [!1, !0] : [!0, !1]), !1;

      case "function":
        return null !== n._nativeSet ? t ? (r = n._nativeSet.size, n._nativeSet.add(e), n._nativeSet.size === r) : n._nativeSet.has(e) : o in n._items ? !!ie(e, n._items[o]) || (t && n._items[o].push(e), !1) : (t && (n._items[o] = [e]), !1);

      case "undefined":
        return !!n._items[o] || (t && (n._items[o] = !0), !1);

      case "object":
        if (null === e) return !!n._items.null || (t && (n._items.null = !0), !1);

      default:
        return (o = Object.prototype.toString.call(e)) in n._items ? !!ie(e, n._items[o]) || (t && n._items[o].push(e), !1) : (t && (n._items[o] = [e]), !1);
    }
  }

  var Ne = c(function (e, t) {
    for (var n, r, o = new Oe(), i = [], s = 0; s < t.length;) {
      n = e(r = t[s]), o.add(n) && i.push(r), s += 1;
    }

    return i;
  })(Re),
      Ue = c(function (e, t) {
    return f(e + 1, function () {
      var n,
          r = arguments[e];
      if (null != r && (n = r[t], "[object Function]" === Object.prototype.toString.call(n))) return r[t].apply(r, Array.prototype.slice.call(arguments, 0, e));
      throw new TypeError(fe(r) + ' does not have a method named "' + t + '"');
    });
  }),
      _e = a(function (e) {
    return null != e && oe(e, ye(e));
  }),
      Ce = Ue(1, "join");

  var Ae = a(function (e) {
    return null != e && (t = e.length, "[object Number]" === Object.prototype.toString.call(t)) ? e.length : NaN;
    var t;
  });

  var Me = c(function (e, t) {
    for (var n = {}, r = 0; r < e.length;) {
      e[r] in t && (n[e[r]] = t[e[r]]), r += 1;
    }

    return n;
  }),
      je = c(function (e, t) {
    return Array.prototype.slice.call(t, 0).sort(e);
  }),
      De = Ue(1, "split"),
      xe = a(function (e) {
    var t = [];

    for (var n in e) {
      _(n, e) && (t[t.length] = [n, e[n]]);
    }

    return t;
  }),
      qe = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
      Be = (String.prototype.trim, "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }),
      Le = function Le(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  },
      He = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }(),
      Fe = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  },
      Ge = function Ge(e, t) {
    var n = {};

    for (var r in e) {
      t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
    }

    return n;
  },
      Je = function () {
    return function (e, t) {
      if (Array.isArray(e)) return e;
      if (Symbol.iterator in Object(e)) return function (e, t) {
        var n = [],
            r = !0,
            o = !1,
            i = void 0;

        try {
          for (var s, u = e[Symbol.iterator](); !(r = (s = u.next()).done) && (n.push(s.value), !t || n.length !== t); r = !0) {
            ;
          }
        } catch (e) {
          o = !0, i = e;
        } finally {
          try {
            !r && u.return && u.return();
          } finally {
            if (o) throw i;
          }
        }

        return n;
      }(e, t);
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
  }(),
      ze = $(le(function (e) {
    return void 0 !== e;
  }), xe, B(function (e) {
    var t = Je(e, 2),
        n = t[0],
        r = t[1];
    return n + "=" + encodeURIComponent(r);
  }), Ce("&")),
      Xe = function Xe(e, t, n) {
    var r = void 0 === n ? "undefined" : Be(n);
    if (r !== t) throw new TypeError("expected " + e + " to be of type " + t + " but was of type " + r);
  },
      Ve = function Ve(e, t, n) {
    Xe(e, "object", n), we(function (n, r) {
      return Xe(e + "." + r, t, n);
    }, n);
  },
      We = function We() {
    return Math.floor(Date.now() / 1e3);
  },
      Ke = function () {
    function e() {
      var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          n = t.url,
          r = t.queryParams,
          o = t.headers;
      Le(this, e), Xe("url", "string", n), r && Xe("queryParams", "object", r), o && Xe("headers", "object", o), this.url = n, this.queryParams = r, this.headers = o, this.fetchToken = this.fetchToken.bind(this), this.fetchFreshToken = this.fetchFreshToken.bind(this), this.cacheIsStale = this.cacheIsStale.bind(this), this.cache = this.cache.bind(this), this.clearCache = this.clearCache.bind(this), this.setUserId = this.setUserId.bind(this);
    }

    return He(e, [{
      key: "fetchToken",
      value: function value() {
        var e = this;
        return this.cacheIsStale() ? (this.req || this.fetchFreshToken()).then(function (t) {
          var n = t.token,
              r = t.expiresIn;
          return e.cache(n, r), n;
        }) : Promise.resolve(this.cachedToken);
      }
    }, {
      key: "fetchFreshToken",
      value: function value() {
        var e,
            t,
            n = this;
        return this.req = s({
          method: "POST",
          url: (e = Fe({
            user_id: this.userId
          }, this.queryParams), t = this.url, t + (pe("?", t) ? "&" : "?") + ze(e)),
          body: ze({
            grant_type: "client_credentials"
          }),
          headers: Fe({
            "content-type": "application/x-www-form-urlencoded"
          }, this.headers)
        }).then(function (e) {
          var t = JSON.parse(e),
              r = t.access_token,
              o = t.expires_in;
          return delete n.req, {
            token: r,
            expiresIn: o
          };
        }).catch(function (e) {
          throw delete n.req, e;
        }), this.req;
      }
    }, {
      key: "cacheIsStale",
      value: function value() {
        return !this.cachedToken || We() > this.cacheExpiresAt;
      }
    }, {
      key: "cache",
      value: function value(e, t) {
        this.cachedToken = e, this.cacheExpiresAt = We() + t;
      }
    }, {
      key: "clearCache",
      value: function value() {
        this.cachedToken = void 0, this.cacheExpiresAt = void 0;
      }
    }, {
      key: "setUserId",
      value: function value(e) {
        this.clearCache(), this.userId = e;
      }
    }]), e;
  }(),
      $e = function $e(e) {
    return {
      createdAt: e.created_at,
      createdByUserId: e.created_by_id,
      id: e.id,
      isPrivate: e.private,
      name: e.name,
      updatedAt: e.updated_at,
      customData: e.custom_data,
      deletedAt: e.deleted_at
    };
  },
      Ye = function Ye(e) {
    return {
      avatarURL: e.avatar_url,
      createdAt: e.created_at,
      customData: e.custom_data,
      id: e.id,
      name: e.name,
      updatedAt: e.updated_at
    };
  },
      Ze = function Ze(e) {
    return {
      id: e.id,
      senderId: e.user_id,
      roomId: e.room_id,
      text: e.text,
      createdAt: e.created_at,
      updatedAt: e.updated_at,
      attachment: e.attachment && et(e.attachment)
    };
  },
      Qe = function Qe(e) {
    return {
      position: e.position,
      updatedAt: e.updated_at,
      userId: e.user_id,
      roomId: e.room_id,
      type: e.cursor_type
    };
  },
      et = function et(e) {
    return {
      link: e.resource_link,
      type: e.type,
      name: e.name
    };
  },
      tt = function () {
    function e() {
      Le(this, e), this.pendingSets = [], this.pendingGets = [], this.initialize = this.initialize.bind(this), this.set = this.set.bind(this), this.get = this.get.bind(this), this.pop = this.pop.bind(this), this.update = this.update.bind(this), this.snapshot = this.snapshot.bind(this), this.getSync = this.getSync.bind(this);
    }

    return He(e, [{
      key: "initialize",
      value: function value(e) {
        var t = this;
        this.store = e, Se(function (e) {
          var n = e.key,
              r = e.value;
          (0, e.resolve)(t.store[n] = r);
        }, this.pendingSets), Se(function (e) {
          var n = e.key;
          (0, e.resolve)(t.store[n]);
        }, this.pendingGets);
      }
    }, {
      key: "set",
      value: function value(e, t) {
        var n = this;
        return this.store ? (this.store[e] = t, Promise.resolve(t)) : new Promise(function (r) {
          n.pendingSets.push({
            key: e,
            value: t,
            resolve: r
          });
        });
      }
    }, {
      key: "get",
      value: function value(e) {
        var t = this;
        return this.store ? Promise.resolve(this.store[e]) : new Promise(function (n) {
          t.pendingGets.push({
            key: e,
            resolve: n
          });
        });
      }
    }, {
      key: "pop",
      value: function value(e) {
        var t = this;
        return this.get(e).then(function (n) {
          return delete t.store[e], n;
        });
      }
    }, {
      key: "update",
      value: function value(e, t) {
        var n = this;
        return this.get(e).then(function (r) {
          return n.set(e, t(r));
        });
      }
    }, {
      key: "snapshot",
      value: function value() {
        return this.store || {};
      }
    }, {
      key: "getSync",
      value: function value(e) {
        return this.store ? this.store[e] : void 0;
      }
    }]), e;
  }(),
      nt = function () {
    function e(t, n) {
      Le(this, e), this.avatarURL = t.avatarURL, this.createdAt = t.createdAt, this.customData = t.customData, this.id = t.id, this.name = t.name, this.updatedAt = t.updatedAt, this.presenceStore = n;
    }

    return He(e, [{
      key: "presence",
      get: function get() {
        return {
          state: this.presenceStore.getSync(this.id) || "unknown"
        };
      }
    }]), e;
  }(),
      rt = function () {
    function e(t) {
      var n = t.instance,
          r = t.presenceStore,
          o = t.logger;
      Le(this, e), this.instance = n, this.presenceStore = r, this.logger = o, this.reqs = {}, this.onSetHooks = [], this.store = new tt(), this.initialize = this.initialize.bind(this), this.set = this.set.bind(this), this.get = this.get.bind(this), this.fetchUser = this.fetchUser.bind(this), this.fetchMissingUsers = this.fetchMissingUsers.bind(this), this.fetchBasicUsers = this.fetchBasicUsers.bind(this), this.snapshot = this.snapshot.bind(this), this.getSync = this.getSync.bind(this), this.decorate = this.decorate.bind(this);
    }

    return He(e, [{
      key: "initialize",
      value: function value(e) {
        this.store.initialize(B(this.decorate, e));
      }
    }, {
      key: "set",
      value: function value(e, t) {
        var n = this;
        return this.store.set(e, this.decorate(t)).then(function () {
          return Se(function (t) {
            return t(e);
          }, n.onSetHooks);
        });
      }
    }, {
      key: "get",
      value: function value(e) {
        return Promise.all([this.fetchUser(e), this.presenceStore.get(e)]).then(function (e) {
          return Je(e, 1)[0];
        });
      }
    }, {
      key: "fetchUser",
      value: function value(e) {
        var t = this;
        return this.fetchMissingUsers([e]).then(function () {
          return t.store.get(e);
        });
      }
    }, {
      key: "fetchMissingUsers",
      value: function value(e) {
        var t = be(e, B(H("id"), J(this.store.snapshot()))),
            n = be(t, q(this.reqs));
        return Ae(n) > 0 && this.fetchBasicUsers(n), Promise.all(J(Me(e, this.reqs)));
      }
    }, {
      key: "fetchBasicUsers",
      value: function value(e) {
        var t,
            n,
            r,
            o,
            i,
            s = this,
            u = this.instance.request({
          method: "GET",
          path: (t = "id", n = e, r = "/users_by_ids", o = pe("?", r) ? "" : "?", i = B(function (e) {
            return encodeURIComponent(t) + "=" + encodeURIComponent(e);
          }, n), r + o + Ce("&", i))
        }).then(function (t) {
          var n = B(Ye, JSON.parse(t));
          return Se(function (e) {
            return s.set(e.id, e);
          }, n), Se(function (e) {
            delete s.reqs[e];
          }, e), n;
        }).catch(function (e) {
          throw s.logger.warn("error fetching missing users:", e), e;
        });
        Se(function (e) {
          s.reqs[e] = u;
        }, e);
      }
    }, {
      key: "snapshot",
      value: function value() {
        var e;
        return (e = this.store).snapshot.apply(e, arguments);
      }
    }, {
      key: "getSync",
      value: function value() {
        var e;
        return (e = this.store).getSync.apply(e, arguments);
      }
    }, {
      key: "decorate",
      value: function value(e) {
        return e ? new nt(e, this.presenceStore) : void 0;
      }
    }]), e;
  }(),
      ot = function () {
    function e(t) {
      var n = t.basicRoom,
          r = t.userStore,
          o = t.isSubscribedTo,
          i = t.logger;
      Le(this, e), this.createdAt = n.createdAt, this.createdByUserId = n.createdByUserId, this.deletedAt = n.deletedAt, this.id = n.id, this.isPrivate = n.isPrivate, this.name = n.name, this.updatedAt = n.updatedAt, this.customData = n.customData, this.userIds = [], this.userStore = r, this.isSubscribedTo = o, this.logger = i;
    }

    return He(e, [{
      key: "users",
      get: function get() {
        var e = this;

        if (!this.isSubscribedTo(this.id)) {
          var t = new Error("Must be subscribed to room " + this.id + " to access users property");
          throw this.logger.error(t), t;
        }

        return le(function (t) {
          return pe(t.id, e.userIds);
        }, J(this.userStore.snapshot()));
      }
    }]), e;
  }(),
      it = function () {
    function e(t) {
      Le(this, e), this.instance = t.instance, this.userStore = t.userStore, this.isSubscribedTo = t.isSubscribedTo, this.logger = t.logger, this.store = new tt(), this.initialize = this.initialize.bind(this), this.set = this.set.bind(this), this.get = this.get.bind(this), this.pop = this.pop.bind(this), this.addUserToRoom = this.addUserToRoom.bind(this), this.removeUserFromRoom = this.removeUserFromRoom.bind(this), this.update = this.update.bind(this), this.fetchBasicRoom = this.fetchBasicRoom.bind(this), this.snapshot = this.snapshot.bind(this), this.getSync = this.getSync.bind(this), this.decorate = this.decorate.bind(this);
    }

    return He(e, [{
      key: "initialize",
      value: function value(e) {
        this.store.initialize(B(this.decorate, e));
      }
    }, {
      key: "set",
      value: function value(e, t) {
        var n = this.store.getSync(e);
        return n ? Promise.resolve(n) : this.store.set(e, this.decorate(t));
      }
    }, {
      key: "get",
      value: function value(e) {
        var t = this;
        return this.store.get(e).then(function (n) {
          return n || t.fetchBasicRoom(e).then(function (n) {
            return t.set(e, n);
          });
        });
      }
    }, {
      key: "pop",
      value: function value() {
        var e;
        return (e = this.store).pop.apply(e, arguments);
      }
    }, {
      key: "addUserToRoom",
      value: function value(e, t) {
        return Promise.all([this.store.update(e, function (e) {
          return e.userIds = Ne(G(t, e.userIds)), e;
        }), this.userStore.fetchMissingUsers([t])]).then(function (e) {
          return Je(e, 1)[0];
        });
      }
    }, {
      key: "removeUserFromRoom",
      value: function value(e, t) {
        return this.store.update(e, function (e) {
          return e.userIds = le(function (e) {
            return e !== t;
          }, e.userIds), e;
        });
      }
    }, {
      key: "update",
      value: function value(e, t) {
        return Promise.all([this.store.update(e, function (e) {
          for (var n in t) {
            e[n] = t[n];
          }

          return e;
        }), this.userStore.fetchMissingUsers(t.userIds || [])]).then(function (e) {
          return Je(e, 1)[0];
        });
      }
    }, {
      key: "fetchBasicRoom",
      value: function value(e) {
        var t = this;
        return this.instance.request({
          method: "GET",
          path: "/rooms/" + encodeURIComponent(e)
        }).then($(JSON.parse, $e)).catch(function (n) {
          t.logger.warn("error fetching details for room " + e + ":", n);
        });
      }
    }, {
      key: "snapshot",
      value: function value() {
        var e;
        return (e = this.store).snapshot.apply(e, arguments);
      }
    }, {
      key: "getSync",
      value: function value() {
        var e;
        return (e = this.store).getSync.apply(e, arguments);
      }
    }, {
      key: "decorate",
      value: function value(e) {
        return e ? new ot({
          basicRoom: e,
          userStore: this.userStore,
          isSubscribedTo: this.isSubscribedTo,
          logger: this.logger
        }) : void 0;
      }
    }]), e;
  }(),
      st = function () {
    function e(t, n, r) {
      Le(this, e), this.position = t.position, this.updatedAt = t.updatedAt, this.userId = t.userId, this.roomId = t.roomId, this.type = t.type, this.userStore = n, this.roomStore = r;
    }

    return He(e, [{
      key: "user",
      get: function get() {
        return this.userStore.getSync(this.userId);
      }
    }, {
      key: "room",
      get: function get() {
        return this.roomStore.getSync(this.roomId);
      }
    }]), e;
  }(),
      ut = function () {
    function e(t) {
      var n = t.instance,
          r = t.userStore,
          o = t.roomStore,
          i = t.logger;
      Le(this, e), this.instance = n, this.userStore = r, this.roomStore = o, this.logger = i, this.store = new tt(), this.initialize = this.initialize.bind(this), this.set = this.set.bind(this), this.get = this.get.bind(this), this.getSync = this.getSync.bind(this), this.fetchBasicCursor = this.fetchBasicCursor.bind(this), this.decorate = this.decorate.bind(this);
    }

    return He(e, [{
      key: "initialize",
      value: function value(e) {
        return this.store.initialize(B(this.decorate, e));
      }
    }, {
      key: "set",
      value: function value(e, t, n) {
        return Promise.all([this.store.set(at(e, t), this.decorate(n)), this.userStore.fetchMissingUsers([e])]);
      }
    }, {
      key: "get",
      value: function value(e, t) {
        var n = this;
        return this.store.get(at(e, t)).then(function (r) {
          return r || n.fetchBasicCursor(e, t).then(function (r) {
            return n.set(e, t, r);
          });
        });
      }
    }, {
      key: "getSync",
      value: function value(e, t) {
        return this.store.getSync(at(e, t));
      }
    }, {
      key: "fetchBasicCursor",
      value: function value(e, t) {
        var n = this;
        return this.instance.request({
          method: "GET",
          path: "/cursors/0/rooms/" + encodeURIComponent(t) + "/users/" + encodeURIComponent(e)
        }).then(function (e) {
          var t = JSON.parse(e);
          if (t) return Qe(t);
        }).catch(function (e) {
          throw n.logger.warn("error fetching cursor:", e), e;
        });
      }
    }, {
      key: "decorate",
      value: function value(e) {
        return e ? new st(e, this.userStore, this.roomStore) : void 0;
      }
    }]), e;
  }(),
      at = function at(e, t) {
    return e + "/" + t;
  },
      ct = 2e4,
      ht = function () {
    function e(t) {
      var n = t.hooks,
          r = t.instance,
          o = t.logger;
      Le(this, e), this.hooks = n, this.instance = r, this.logger = o, this.lastSentRequests = {}, this.timers = {}, this.sendThrottledRequest = this.sendThrottledRequest.bind(this), this.onIsTyping = this.onIsTyping.bind(this), this.onStarted = this.onStarted.bind(this), this.onStopped = this.onStopped.bind(this);
    }

    return He(e, [{
      key: "sendThrottledRequest",
      value: function value(e) {
        var t = this,
            n = Date.now(),
            r = this.lastSentRequests[e];
        return r && n - r < 1e3 ? Promise.resolve() : (this.lastSentRequests[e] = n, this.instance.request({
          method: "POST",
          path: "/rooms/" + encodeURIComponent(e) + "/typing_indicators"
        }).catch(function (n) {
          throw delete t.typingRequestSent[e], t.logger.warn("Error sending typing indicator in room " + e, n), n;
        }));
      }
    }, {
      key: "onIsTyping",
      value: function value(e, t) {
        var n = this;
        this.timers[e.id] || (this.timers[e.id] = {}), this.timers[e.id][t.id] ? clearTimeout(this.timers[e.id][t.id]) : this.onStarted(e, t), this.timers[e.id][t.id] = setTimeout(function () {
          n.onStopped(e, t), delete n.timers[e.id][t.id];
        }, 1500);
      }
    }, {
      key: "onStarted",
      value: function value(e, t) {
        this.hooks.global.onUserStartedTyping && this.hooks.global.onUserStartedTyping(e, t), this.hooks.rooms[e.id] && this.hooks.rooms[e.id].onUserStartedTyping && this.hooks.rooms[e.id].onUserStartedTyping(t);
      }
    }, {
      key: "onStopped",
      value: function value(e, t) {
        this.hooks.global.onUserStoppedTyping && this.hooks.global.onUserStoppedTyping(e, t), this.hooks.rooms[e.id] && this.hooks.rooms[e.id].onUserStoppedTyping && this.hooks.rooms[e.id].onUserStoppedTyping(t);
      }
    }]), e;
  }(),
      lt = function () {
    function e(t) {
      Le(this, e), this.userId = t.userId, this.hooks = t.hooks, this.instance = t.instance, this.userStore = t.userStore, this.roomStore = t.roomStore, this.roomSubscriptions = t.roomSubscriptions, this.logger = t.logger, this.connectionTimeout = t.connectionTimeout, this.connect = this.connect.bind(this), this.cancel = this.cancel.bind(this), this.onEvent = this.onEvent.bind(this), this.onInitialState = this.onInitialState.bind(this), this.onAddedToRoom = this.onAddedToRoom.bind(this), this.onRemovedFromRoom = this.onRemovedFromRoom.bind(this), this.onRoomUpdated = this.onRoomUpdated.bind(this), this.onRoomDeleted = this.onRoomDeleted.bind(this);
    }

    return He(e, [{
      key: "connect",
      value: function value() {
        var e = this;
        return new Promise(function (t, n) {
          e.timeout = setTimeout(function () {
            n(new Error("user subscription timed out"));
          }, e.connectionTimeout), e.onSubscriptionEstablished = function (n) {
            clearTimeout(e.timeout), t(n);
          }, e.sub = e.instance.subscribeNonResuming({
            path: "/users",
            listeners: {
              onError: function onError(t) {
                clearTimeout(e.timeout), n(t);
              },
              onEvent: e.onEvent
            }
          });
        });
      }
    }, {
      key: "cancel",
      value: function value() {
        clearTimeout(this.timeout);

        try {
          this.sub && this.sub.unsubscribe();
        } catch (e) {
          this.logger.debug("error when cancelling user subscription", e);
        }
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        var t = e.body;

        switch (t.event_name) {
          case "initial_state":
            this.onInitialState(t.data);
            break;

          case "added_to_room":
            this.onAddedToRoom(t.data);
            break;

          case "removed_from_room":
            this.onRemovedFromRoom(t.data);
            break;

          case "room_updated":
            this.onRoomUpdated(t.data);
            break;

          case "room_deleted":
            this.onRoomDeleted(t.data);
        }
      }
    }, {
      key: "onInitialState",
      value: function value(e) {
        var t = e.current_user,
            n = e.rooms;
        this.onSubscriptionEstablished({
          user: Ye(t),
          basicRooms: B($e, n)
        });
      }
    }, {
      key: "onAddedToRoom",
      value: function value(e) {
        var t = this,
            n = e.room,
            r = $e(n);
        this.roomStore.set(r.id, r).then(function (e) {
          t.hooks.global.onAddedToRoom && t.hooks.global.onAddedToRoom(e);
        });
      }
    }, {
      key: "onRemovedFromRoom",
      value: function value(e) {
        var t = this,
            n = e.room_id;
        this.roomStore.pop(n).then(function (e) {
          e && t.hooks.global.onRemovedFromRoom && t.hooks.global.onRemovedFromRoom(e);
        });
      }
    }, {
      key: "onRoomUpdated",
      value: function value(e) {
        var t = this,
            n = e.room,
            r = $e(n);
        this.roomStore.update(r.id, r).then(function (e) {
          t.hooks.global.onRoomUpdated && t.hooks.global.onRoomUpdated(e);
        });
      }
    }, {
      key: "onRoomDeleted",
      value: function value(e) {
        var t = this,
            n = e.room_id;
        this.roomStore.pop(n).then(function (e) {
          e && t.hooks.global.onRoomDeleted && t.hooks.global.onRoomDeleted(e);
        });
      }
    }]), e;
  }(),
      dt = function () {
    function e(t) {
      Le(this, e), this.userId = t.userId, this.instance = t.instance, this.logger = t.logger, this.connectionTimeout = t.connectionTimeout;
    }

    return He(e, [{
      key: "connect",
      value: function value() {
        var e = this;
        return new Promise(function (t, n) {
          e.timeout = setTimeout(function () {
            n(new Error("presence subscription timed out"));
          }, e.connectionTimeout), e.sub = e.instance.subscribeNonResuming({
            path: "/users/" + encodeURIComponent(e.userId) + "/register",
            listeners: {
              onOpen: function onOpen() {
                clearTimeout(e.timeout), t();
              },
              onError: function onError(t) {
                clearTimeout(e.timeout), n(t);
              }
            }
          });
        });
      }
    }, {
      key: "cancel",
      value: function value() {
        clearTimeout(this.timeout);

        try {
          this.sub && this.sub.unsubscribe();
        } catch (e) {
          this.logger.debug("error when cancelling presence subscription", e);
        }
      }
    }]), e;
  }(),
      ft = function () {
    function e(t) {
      Le(this, e), this.userId = t.userId, this.hooks = t.hooks, this.instance = t.instance, this.userStore = t.userStore, this.roomStore = t.roomStore, this.presenceStore = t.presenceStore, this.logger = t.logger, this.connectionTimeout = t.connectionTimeout, this.connect = this.connect.bind(this), this.cancel = this.cancel.bind(this), this.onEvent = this.onEvent.bind(this), this.onPresenceState = this.onPresenceState.bind(this);
    }

    return He(e, [{
      key: "connect",
      value: function value() {
        var e = this;
        return new Promise(function (t, n) {
          e.timeout = setTimeout(function () {
            n(new Error("user presence subscription timed out"));
          }, e.connectionTimeout), e.onSubscriptionEstablished = function () {
            clearTimeout(e.timeout), t();
          }, e.sub = e.instance.subscribeNonResuming({
            path: "/users/" + encodeURIComponent(e.userId),
            listeners: {
              onError: function onError(t) {
                clearTimeout(e.timeout), n(t);
              },
              onEvent: e.onEvent
            }
          });
        });
      }
    }, {
      key: "cancel",
      value: function value() {
        clearTimeout(this.timeout);

        try {
          this.sub && this.sub.unsubscribe();
        } catch (e) {
          this.logger.debug("error when cancelling user presence subscription", e);
        }
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        var t = e.body;

        switch (t.event_name) {
          case "presence_state":
            this.onPresenceState(t.data);
        }
      }
    }, {
      key: "onPresenceState",
      value: function value(e) {
        var t = this;
        this.onSubscriptionEstablished();

        var n = this.presenceStore.getSync(this.userId) || "unknown",
            r = function (e) {
          return {
            state: pe(e.state, ["online", "offline"]) ? e.state : "unknown"
          };
        }(e).state;

        r !== n && this.presenceStore.set(this.userId, r).then(function () {
          t.userStore.get(t.userId).then(function (e) {
            t.hooks.global.onPresenceChanged && t.hooks.global.onPresenceChanged({
              current: r,
              previous: n
            }, e), Z(Se(function (o) {
              var i = Je(o, 2),
                  s = i[0],
                  u = i[1];
              return t.roomStore.get(s).then(function (t) {
                pe(e.id, t.userIds) && u.onPresenceChanged({
                  current: r,
                  previous: n
                }, e);
              });
            }), le(function (e) {
              return void 0 !== e[1].onPresenceChanged;
            }), xe)(t.hooks.rooms);
          });
        });
      }
    }]), e;
  }(),
      pt = function () {
    function e(t) {
      Le(this, e), this.onNewCursorHook = t.onNewCursorHook, this.path = t.path, this.cursorStore = t.cursorStore, this.instance = t.instance, this.logger = t.logger, this.connectionTimeout = t.connectionTimeout, this.connect = this.connect.bind(this), this.cancel = this.cancel.bind(this), this.onEvent = this.onEvent.bind(this), this.onInitialState = this.onInitialState.bind(this), this.onNewCursor = this.onNewCursor.bind(this);
    }

    return He(e, [{
      key: "connect",
      value: function value() {
        var e = this;
        return new Promise(function (t, n) {
          e.timeout = setTimeout(function () {
            n(new Error("cursor subscription timed out"));
          }, e.connectionTimeout), e.onSubscriptionEstablished = function (n) {
            clearTimeout(e.timeout), t(n);
          }, e.sub = e.instance.subscribeNonResuming({
            path: e.path,
            listeners: {
              onError: function onError(t) {
                clearTimeout(e.timeout), n(t);
              },
              onEvent: e.onEvent
            }
          });
        });
      }
    }, {
      key: "cancel",
      value: function value() {
        clearTimeout(this.timeout);

        try {
          this.sub && this.sub.unsubscribe();
        } catch (e) {
          this.logger.debug("error when cancelling cursor subscription", e);
        }
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        var t = e.body;

        switch (t.event_name) {
          case "initial_state":
            this.onInitialState(t.data);
            break;

          case "new_cursor":
            this.onNewCursor(t.data);
        }
      }
    }, {
      key: "onInitialState",
      value: function value(e) {
        var t = this,
            n = e.cursors;
        return Promise.all(B(function (e) {
          return t.cursorStore.set(e.userId, e.roomId, e);
        }, B(Qe, n))).then(this.onSubscriptionEstablished);
      }
    }, {
      key: "onNewCursor",
      value: function value(e) {
        var t = this,
            n = Qe(e);
        return this.cursorStore.set(n.userId, n.roomId, n).then(function () {
          t.cursorStore.get(n.userId, n.roomId).then(t.onNewCursorHook);
        });
      }
    }]), e;
  }(),
      gt = function () {
    function e(t, n, r) {
      Le(this, e), this.id = t.id, this.senderId = t.senderId, this.roomId = t.roomId, this.text = t.text, this.attachment = t.attachment, this.createdAt = t.createdAt, this.updatedAt = t.updatedAt, this.userStore = n, this.roomStore = r;
    }

    return He(e, [{
      key: "sender",
      get: function get() {
        return this.userStore.getSync(this.senderId);
      }
    }, {
      key: "room",
      get: function get() {
        return this.roomStore.getSync(this.roomId);
      }
    }]), e;
  }(),
      mt = function () {
    function e(t) {
      Le(this, e), this.roomId = t.roomId, this.hooks = t.hooks, this.messageLimit = t.messageLimit, this.userId = t.userId, this.instance = t.instance, this.userStore = t.userStore, this.roomStore = t.roomStore, this.typingIndicators = t.typingIndicators, this.messageBuffer = [], this.logger = t.logger, this.connectionTimeout = t.connectionTimeout, this.connect = this.connect.bind(this), this.cancel = this.cancel.bind(this), this.onEvent = this.onEvent.bind(this), this.onMessage = this.onMessage.bind(this), this.flushBuffer = this.flushBuffer.bind(this), this.onIsTyping = this.onIsTyping.bind(this);
    }

    return He(e, [{
      key: "connect",
      value: function value() {
        var e = this;
        return new Promise(function (t, n) {
          e.timeout = setTimeout(function () {
            n(new Error("message subscription timed out"));
          }, e.connectionTimeout), e.sub = e.instance.subscribeResuming({
            path: "/rooms/" + encodeURIComponent(e.roomId) + "?" + ze({
              message_limit: e.messageLimit
            }),
            listeners: {
              onOpen: function onOpen() {
                clearTimeout(e.timeout), t();
              },
              onError: function onError(t) {
                clearTimeout(e.timeout), n(t);
              },
              onEvent: e.onEvent
            }
          });
        });
      }
    }, {
      key: "cancel",
      value: function value() {
        clearTimeout(this.timeout);

        try {
          this.sub && this.sub.unsubscribe();
        } catch (e) {
          this.logger.debug("error when cancelling message subscription", e);
        }
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        var t = e.body;

        switch (t.event_name) {
          case "new_message":
            this.onMessage(t.data);
            break;

          case "is_typing":
            this.onIsTyping(t.data);
        }
      }
    }, {
      key: "onMessage",
      value: function value(e) {
        var t = this,
            n = {
          message: new gt(Ze(e), this.userStore, this.roomStore),
          ready: !1
        };
        this.messageBuffer.push(n), this.userStore.fetchMissingUsers([n.message.senderId]).catch(function (e) {
          t.logger.error("error fetching missing user information:", e);
        }).then(function () {
          n.ready = !0, t.flushBuffer();
        });
      }
    }, {
      key: "flushBuffer",
      value: function value() {
        for (; !_e(this.messageBuffer) && Ie(this.messageBuffer).ready;) {
          var e = this.messageBuffer.shift().message;
          this.hooks.rooms[this.roomId] && this.hooks.rooms[this.roomId].onMessage && this.hooks.rooms[this.roomId].onMessage(e);
        }
      }
    }, {
      key: "onIsTyping",
      value: function value(e) {
        var t = this,
            n = e.user_id;
        n !== this.userId && Promise.all([this.roomStore.get(this.roomId), this.userStore.get(n)]).then(function (e) {
          var n = Je(e, 2),
              r = n[0],
              o = n[1];
          return t.typingIndicators.onIsTyping(r, o);
        });
      }
    }]), e;
  }(),
      bt = function () {
    function e(t) {
      Le(this, e), this.roomId = t.roomId, this.hooks = t.hooks, this.instance = t.instance, this.userStore = t.userStore, this.roomStore = t.roomStore, this.logger = t.logger, this.connectionTimeout = t.connectionTimeout, this.connect = this.connect.bind(this), this.cancel = this.cancel.bind(this), this.onEvent = this.onEvent.bind(this), this.onInitialState = this.onInitialState.bind(this), this.onUserJoined = this.onUserJoined.bind(this), this.onUserLeft = this.onUserLeft.bind(this);
    }

    return He(e, [{
      key: "connect",
      value: function value() {
        var e = this;
        return new Promise(function (t, n) {
          e.timeout = setTimeout(function () {
            n(new Error("membership subscription timed out"));
          }, e.connectionTimeout), e.onSubscriptionEstablished = function (n) {
            clearTimeout(e.timeout), t(n);
          }, e.sub = e.instance.subscribeNonResuming({
            path: "/rooms/" + encodeURIComponent(e.roomId) + "/memberships",
            listeners: {
              onError: function onError(t) {
                clearTimeout(e.timeout), n(t);
              },
              onEvent: e.onEvent
            }
          });
        });
      }
    }, {
      key: "cancel",
      value: function value() {
        clearTimeout(this.timeout);

        try {
          this.sub && this.sub.unsubscribe();
        } catch (e) {
          this.logger.debug("error when cancelling membership subscription", e);
        }
      }
    }, {
      key: "onEvent",
      value: function value(e) {
        var t = e.body;

        switch (t.event_name) {
          case "initial_state":
            this.onInitialState(t.data);
            break;

          case "user_joined":
            this.onUserJoined(t.data);
            break;

          case "user_left":
            this.onUserLeft(t.data);
        }
      }
    }, {
      key: "onInitialState",
      value: function value(e) {
        var t = this,
            n = e.user_ids;
        this.roomStore.update(this.roomId, {
          userIds: n
        }).then(function () {
          t.onSubscriptionEstablished();
        });
      }
    }, {
      key: "onUserJoined",
      value: function value(e) {
        var t = this,
            n = e.user_id;
        this.roomStore.addUserToRoom(this.roomId, n).then(function (e) {
          t.userStore.get(n).then(function (n) {
            t.hooks.global.onUserJoinedRoom && t.hooks.global.onUserJoinedRoom(e, n), t.hooks.rooms[t.roomId] && t.hooks.rooms[t.roomId].onUserJoined && t.hooks.rooms[t.roomId].onUserJoined(n);
          });
        });
      }
    }, {
      key: "onUserLeft",
      value: function value(e) {
        var t = this,
            n = e.user_id;
        this.roomStore.removeUserFromRoom(this.roomId, n).then(function (e) {
          t.userStore.get(n).then(function (n) {
            t.hooks.global.onUserLeftRoom && t.hooks.global.onUserLeftRoom(e, n), t.hooks.rooms[t.roomId] && t.hooks.rooms[t.roomId].onUserLeft && t.hooks.rooms[t.roomId].onUserLeft(n);
          });
        });
      }
    }]), e;
  }(),
      vt = function () {
    function e(t) {
      Le(this, e), this.messageSub = t.messageSub, this.cursorSub = t.cursorSub, this.membershipSub = t.membershipSub;
    }

    return He(e, [{
      key: "connect",
      value: function value() {
        return Promise.all([this.messageSub.connect(), this.cursorSub.connect(), this.membershipSub.connect()]);
      }
    }, {
      key: "cancel",
      value: function value() {
        this.messageSub.cancel(), this.cursorSub.cancel(), this.membershipSub.cancel();
      }
    }]), e;
  }(),
      yt = function () {
    function e(t) {
      var n = this,
          r = t.apiInstance,
          o = t.connectionTimeout,
          i = t.cursorsInstance,
          s = t.filesInstance,
          u = t.hooks,
          a = t.id,
          c = t.presenceInstance;
      Le(this, e), this.hooks = {
        global: u,
        rooms: {}
      }, this.id = a, this.encodedId = encodeURIComponent(this.id), this.apiInstance = r, this.filesInstance = s, this.cursorsInstance = i, this.connectionTimeout = o, this.presenceInstance = c, this.logger = r.logger, this.presenceStore = new tt(), this.userStore = new rt({
        instance: this.apiInstance,
        presenceStore: this.presenceStore,
        logger: this.logger
      }), this.roomStore = new it({
        instance: this.apiInstance,
        userStore: this.userStore,
        isSubscribedTo: function isSubscribedTo(e) {
          return n.isSubscribedTo(e);
        },
        logger: this.logger
      }), this.cursorStore = new ut({
        instance: this.cursorsInstance,
        userStore: this.userStore,
        roomStore: this.roomStore,
        logger: this.logger
      }), this.typingIndicators = new ht({
        hooks: this.hooks,
        instance: this.apiInstance,
        logger: this.logger
      }), this.userStore.onSetHooks.push(function (e) {
        return n.subscribeToUserPresence(e);
      }), this.userStore.initialize({}), this.presenceStore.initialize({}), this.cursorStore.initialize({}), this.roomSubscriptions = {}, this.readCursorBuffer = {}, this.userPresenceSubscriptions = {}, this.setReadCursor = this.setReadCursor.bind(this), this.readCursor = this.readCursor.bind(this), this.isTypingIn = this.isTypingIn.bind(this), this.createRoom = this.createRoom.bind(this), this.getJoinableRooms = this.getJoinableRooms.bind(this), this.joinRoom = this.joinRoom.bind(this), this.leaveRoom = this.leaveRoom.bind(this), this.addUserToRoom = this.addUserToRoom.bind(this), this.removeUserFromRoom = this.removeUserFromRoom.bind(this), this.sendMessage = this.sendMessage.bind(this), this.fetchMessages = this.fetchMessages.bind(this), this.subscribeToRoom = this.subscribeToRoom.bind(this), this.updateRoom = this.updateRoom.bind(this), this.deleteRoom = this.deleteRoom.bind(this), this.setReadCursorRequest = this.setReadCursorRequest.bind(this), this.uploadDataAttachment = this.uploadDataAttachment.bind(this), this.isMemberOf = this.isMemberOf.bind(this), this.isSubscribedTo = this.isSubscribedTo.bind(this), this.decorateMessage = this.decorateMessage.bind(this), this.establishUserSubscription = this.establishUserSubscription.bind(this), this.establishCursorSubscription = this.establishCursorSubscription.bind(this), this.establishPresenceSubscription = this.establishPresenceSubscription.bind(this), this.subscribeToUserPresence = this.subscribeToUserPresence.bind(this), this.disconnect = this.disconnect.bind(this);
    }

    return He(e, [{
      key: "setReadCursor",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.roomId,
            r = t.position;
        return Xe("roomId", "string", n), Xe("position", "number", r), new Promise(function (t, o) {
          void 0 !== e.readCursorBuffer[n] ? (e.readCursorBuffer[n].position = v(e.readCursorBuffer[n].position, r), e.readCursorBuffer[n].callbacks.push({
            resolve: t,
            reject: o
          })) : (e.readCursorBuffer[n] = {
            position: r,
            callbacks: [{
              resolve: t,
              reject: o
            }]
          }, setTimeout(function () {
            e.setReadCursorRequest(Fe({
              roomId: n
            }, e.readCursorBuffer[n])), delete e.readCursorBuffer[n];
          }, 500));
        });
      }
    }, {
      key: "readCursor",
      value: function value() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.roomId,
            n = e.userId,
            r = void 0 === n ? this.id : n;

        if (Xe("roomId", "string", t), Xe("userId", "string", r), r !== this.id && !this.isSubscribedTo(t)) {
          var o = new Error("Must be subscribed to room " + t + " to access member's read cursors");
          throw this.logger.error(o), o;
        }

        return this.cursorStore.getSync(r, t);
      }
    }, {
      key: "isTypingIn",
      value: function value() {
        var e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).roomId;
        return Xe("roomId", "string", e), this.typingIndicators.sendThrottledRequest(e);
      }
    }, {
      key: "createRoom",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.name,
            r = t.addUserIds,
            o = t.customData,
            i = Ge(t, ["name", "addUserIds", "customData"]);
        return n && Xe("name", "string", n), r && function (e, t, n) {
          if (!Array.isArray(n)) throw new TypeError("expected " + e + " to be an array");
          n.forEach(function (n, r) {
            return Xe(e + "[" + r + "]", t, n);
          });
        }("addUserIds", "string", r), o && Xe("customData", "object", o), this.apiInstance.request({
          method: "POST",
          path: "/rooms",
          json: {
            created_by_id: this.id,
            name: n,
            private: !!i.private,
            user_ids: r,
            custom_data: o
          }
        }).then(function (t) {
          var n = $e(JSON.parse(t));
          return e.roomStore.set(n.id, n);
        }).catch(function (t) {
          throw e.logger.warn("error creating room:", t), t;
        });
      }
    }, {
      key: "getJoinableRooms",
      value: function value() {
        var e = this;
        return this.apiInstance.request({
          method: "GET",
          path: "/users/" + this.encodedId + "/rooms?joinable=true"
        }).then($(JSON.parse, B($e))).catch(function (t) {
          throw e.logger.warn("error getting joinable rooms:", t), t;
        });
      }
    }, {
      key: "joinRoom",
      value: function value() {
        var e = this,
            t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).roomId;
        return Xe("roomId", "string", t), this.isMemberOf(t) ? this.roomStore.get(t) : this.apiInstance.request({
          method: "POST",
          path: "/users/" + this.encodedId + "/rooms/" + encodeURIComponent(t) + "/join"
        }).then(function (t) {
          var n = $e(JSON.parse(t));
          return e.roomStore.set(n.id, n);
        }).catch(function (n) {
          throw e.logger.warn("error joining room " + t + ":", n), n;
        });
      }
    }, {
      key: "leaveRoom",
      value: function value() {
        var e = this,
            t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).roomId;
        return Xe("roomId", "string", t), this.roomStore.get(t).then(function (n) {
          return e.apiInstance.request({
            method: "POST",
            path: "/users/" + e.encodedId + "/rooms/" + encodeURIComponent(t) + "/leave"
          }).then(function () {
            return e.roomStore.pop(t);
          }).then(function () {
            return n;
          });
        }).catch(function (n) {
          throw e.logger.warn("error leaving room " + t + ":", n), n;
        });
      }
    }, {
      key: "addUserToRoom",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.userId,
            r = t.roomId;
        return Xe("userId", "string", n), Xe("roomId", "string", r), this.apiInstance.request({
          method: "PUT",
          path: "/rooms/" + encodeURIComponent(r) + "/users/add",
          json: {
            user_ids: [n]
          }
        }).then(function () {
          return e.roomStore.addUserToRoom(r, n);
        }).catch(function (t) {
          throw e.logger.warn("error adding user " + n + " to room " + r + ":", t), t;
        });
      }
    }, {
      key: "removeUserFromRoom",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.userId,
            r = t.roomId;
        return Xe("userId", "string", n), Xe("roomId", "string", r), this.apiInstance.request({
          method: "PUT",
          path: "/rooms/" + encodeURIComponent(r) + "/users/remove",
          json: {
            user_ids: [n]
          }
        }).then(function () {
          return e.roomStore.removeUserFromRoom(r, n);
        }).catch(function (t) {
          throw e.logger.warn("error removing user " + n + " from room " + r + ":", t), t;
        });
      }
    }, {
      key: "sendMessage",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.text,
            r = t.roomId,
            o = t.attachment;
        return Xe("text", "string", n), Xe("roomId", "string", r), new Promise(function (t, n) {
          void 0 !== o && St(o) ? t(e.uploadDataAttachment(r, o)) : void 0 !== o && wt(o) ? t({
            resource_link: o.link,
            type: o.type
          }) : void 0 !== o ? n(new TypeError("attachment was malformed")) : t();
        }).then(function (t) {
          return e.apiInstance.request({
            method: "POST",
            path: "/rooms/" + encodeURIComponent(r) + "/messages",
            json: {
              text: n,
              attachment: t
            }
          });
        }).then($(JSON.parse, H("message_id"))).catch(function (t) {
          throw e.logger.warn("error sending message to room " + r + ":", t), t;
        });
      }
    }, {
      key: "fetchMessages",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.roomId,
            r = t.initialId,
            o = t.limit,
            i = t.direction;
        return Xe("roomId", "string", n), r && Xe("initialId", "number", r), o && Xe("limit", "number", o), i && function (e, t, n) {
          if (!pe(n, t)) throw new TypeError("expected " + e + " to be one of " + t + " but was " + n);
        }("direction", ["older", "newer"], i), this.apiInstance.request({
          method: "GET",
          path: "/rooms/" + encodeURIComponent(n) + "/messages?" + ze({
            initial_id: r,
            limit: o,
            direction: i
          })
        }).then(function (t) {
          var n = B(Z(e.decorateMessage, Ze), JSON.parse(t));
          return e.userStore.fetchMissingUsers(Ne(B(H("senderId"), n))).then(function () {
            return je(function (e, t) {
              return e.id - t.id;
            }, n);
          });
        }).catch(function (t) {
          throw e.logger.warn("error fetching messages from room " + n + ":", t), t;
        });
      }
    }, {
      key: "subscribeToRoom",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.roomId,
            r = t.hooks,
            o = void 0 === r ? {} : r,
            i = t.messageLimit;
        return Xe("roomId", "string", n), Ve("hooks", "function", o), i && Xe("messageLimit", "number", i), this.roomSubscriptions[n] && this.roomSubscriptions[n].cancel(), this.hooks.rooms[n] = o, this.roomSubscriptions[n] = new vt({
          messageSub: new mt({
            roomId: n,
            hooks: this.hooks,
            messageLimit: i,
            userId: this.id,
            instance: this.apiInstance,
            userStore: this.userStore,
            roomStore: this.roomStore,
            typingIndicators: this.typingIndicators,
            logger: this.logger,
            connectionTimeout: this.connectionTimeout
          }),
          cursorSub: new pt({
            onNewCursorHook: function onNewCursorHook(t) {
              e.hooks.rooms[n] && e.hooks.rooms[n].onNewReadCursor && 0 === t.type && t.userId !== e.id && e.hooks.rooms[n].onNewReadCursor(t);
            },
            path: "/cursors/0/rooms/" + encodeURIComponent(n),
            cursorStore: this.cursorStore,
            instance: this.cursorsInstance,
            logger: this.logger,
            connectionTimeout: this.connectionTimeout
          }),
          membershipSub: new bt({
            roomId: n,
            hooks: this.hooks,
            instance: this.apiInstance,
            userStore: this.userStore,
            roomStore: this.roomStore,
            logger: this.logger,
            connectionTimeout: this.connectionTimeout
          })
        }), this.joinRoom({
          roomId: n
        }).then(function (t) {
          return e.roomSubscriptions[n].connect().then(function () {
            return t;
          });
        }).catch(function (t) {
          throw e.logger.warn("error subscribing to room " + n + ":", t), t;
        });
      }
    }, {
      key: "updateRoom",
      value: function value() {
        var e = this,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.roomId,
            r = t.name,
            o = t.customData,
            i = Ge(t, ["roomId", "name", "customData"]);
        return Xe("roomId", "string", n), r && Xe("name", "string", r), i.private && Xe("private", "boolean", i.private), o && Xe("customData", "object", o), this.apiInstance.request({
          method: "PUT",
          path: "/rooms/" + encodeURIComponent(n),
          json: {
            name: r,
            private: i.private,
            custom_data: o
          }
        }).then(function () {}).catch(function (t) {
          throw e.logger.warn("error updating room:", t), t;
        });
      }
    }, {
      key: "deleteRoom",
      value: function value() {
        var e = this,
            t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).roomId;
        return Xe("roomId", "string", t), this.apiInstance.request({
          method: "DELETE",
          path: "/rooms/" + encodeURIComponent(t)
        }).then(function () {}).catch(function (t) {
          throw e.logger.warn("error deleting room:", t), t;
        });
      }
    }, {
      key: "setReadCursorRequest",
      value: function value(e) {
        var t = this,
            n = e.roomId,
            r = e.position,
            o = e.callbacks;
        return this.cursorsInstance.request({
          method: "PUT",
          path: "/cursors/0/rooms/" + encodeURIComponent(n) + "/users/" + this.encodedId,
          json: {
            position: r
          }
        }).then(function () {
          return B(function (e) {
            return e.resolve();
          }, o);
        }).catch(function (e) {
          t.logger.warn("error setting cursor:", e), B(function (t) {
            return t.reject(e);
          }, o);
        });
      }
    }, {
      key: "uploadDataAttachment",
      value: function value(e, t) {
        var n = t.file,
            r = t.name,
            o = new FormData();
        return o.append("file", n, r), this.filesInstance.request({
          method: "POST",
          path: "/rooms/" + encodeURIComponent(e) + "/users/" + this.encodedId + "/files/" + encodeURIComponent(r),
          body: o
        }).then(JSON.parse);
      }
    }, {
      key: "isMemberOf",
      value: function value(e) {
        return pe(e, B(H("id"), this.rooms));
      }
    }, {
      key: "isSubscribedTo",
      value: function value(e) {
        return Ee(e, this.roomSubscriptions);
      }
    }, {
      key: "decorateMessage",
      value: function value(e) {
        return new gt(e, this.userStore, this.roomStore);
      }
    }, {
      key: "establishUserSubscription",
      value: function value() {
        var e = this;
        return this.userSubscription = new lt({
          hooks: this.hooks,
          userId: this.id,
          instance: this.apiInstance,
          userStore: this.userStore,
          roomStore: this.roomStore,
          typingIndicators: this.typingIndicators,
          logger: this.logger,
          connectionTimeout: this.connectionTimeout
        }), this.userSubscription.connect().then(function (t) {
          var n = t.user,
              r = t.basicRooms;
          e.avatarURL = n.avatarURL, e.createdAt = n.createdAt, e.customData = n.customData, e.name = n.name, e.updatedAt = n.updatedAt, e.roomStore.initialize(Te(H("id"), r));
        }).catch(function (t) {
          throw e.logger.error("error establishing user subscription:", t), t;
        });
      }
    }, {
      key: "establishCursorSubscription",
      value: function value() {
        var e = this;
        return this.cursorSubscription = new pt({
          onNewCursorHook: function onNewCursorHook(t) {
            e.hooks.global.onNewReadCursor && 0 === t.type && e.isMemberOf(t.roomId) && e.hooks.global.onNewReadCursor(t);
          },
          path: "/cursors/0/users/" + this.encodedId,
          cursorStore: this.cursorStore,
          instance: this.cursorsInstance,
          logger: this.logger,
          connectionTimeout: this.connectionTimeout
        }), this.cursorSubscription.connect().catch(function (t) {
          throw e.logger.error("error establishing cursor subscription:", t), t;
        });
      }
    }, {
      key: "establishPresenceSubscription",
      value: function value() {
        var e = this;
        return this.presenceSubscription = new dt({
          userId: this.id,
          instance: this.presenceInstance,
          logger: this.logger,
          connectionTimeout: this.connectionTimeout
        }), Promise.all([this.userStore.fetchBasicUsers([this.id]), this.subscribeToUserPresence(this.id), this.presenceSubscription.connect().catch(function (t) {
          throw e.logger.warn("error establishing presence subscription:", t), t;
        })]);
      }
    }, {
      key: "subscribeToUserPresence",
      value: function value(e) {
        if (this.userPresenceSubscriptions[e]) return Promise.resolve();
        var t = new ft({
          hooks: this.hooks,
          userId: e,
          instance: this.presenceInstance,
          userStore: this.userStore,
          roomStore: this.roomStore,
          presenceStore: this.presenceStore,
          logger: this.logger,
          connectionTimeout: this.connectionTimeout
        });
        return this.userPresenceSubscriptions[e] = t, t.connect();
      }
    }, {
      key: "disconnect",
      value: function value() {
        this.userSubscription.cancel(), this.presenceSubscription.cancel(), this.cursorSubscription.cancel(), we(function (e) {
          return e.cancel();
        }, this.roomSubscriptions), we(function (e) {
          return e.cancel();
        }, this.userPresenceSubscriptions);
      }
    }, {
      key: "rooms",
      get: function get() {
        return J(this.roomStore.snapshot());
      }
    }, {
      key: "users",
      get: function get() {
        return J(this.userStore.snapshot());
      }
    }]), e;
  }(),
      St = function St(e) {
    var t = e.file,
        n = e.name;
    return void 0 !== t && void 0 !== n && (Xe("attachment.file", "object", t), Xe("attachment.name", "string", n), !0);
  },
      wt = function wt(e) {
    var t = e.link,
        n = e.type;
    return void 0 !== t && void 0 !== n && (Xe("attachment.link", "string", t), Xe("attachment.type", "string", n), !0);
  },
      Et = "1.2.1";

  return {
    TokenProvider: Ke,
    ChatManager: function () {
      function e() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.instanceLocator,
            s = t.tokenProvider,
            u = t.userId,
            a = Ge(t, ["instanceLocator", "tokenProvider", "userId"]);
        Le(this, e), Xe("instanceLocator", "string", n), Xe("tokenProvider", "object", s), Xe("tokenProvider.fetchToken", "function", s.fetchToken), Xe("userId", "string", u);
        var c = De(":", n)[1];
        if (void 0 === c) throw new TypeError("expected instanceLocator to be of the format x:y:z, but was " + n);
        var h = a.baseClient || new r({
          host: c + "." + o,
          logger: a.logger,
          sdkProduct: "chatkit",
          sdkVersion: Et
        });
        "function" == typeof s.setUserId && s.setUserId(u);
        var l = {
          client: h,
          locator: n,
          logger: a.logger,
          tokenProvider: s
        };
        this.apiInstance = new i(Fe({
          serviceName: "chatkit",
          serviceVersion: "v2"
        }, l)), this.filesInstance = new i(Fe({
          serviceName: "chatkit_files",
          serviceVersion: "v1"
        }, l)), this.cursorsInstance = new i(Fe({
          serviceName: "chatkit_cursors",
          serviceVersion: "v2"
        }, l)), this.presenceInstance = new i(Fe({
          serviceName: "chatkit_presence",
          serviceVersion: "v2"
        }, l)), this.userId = u, this.connectionTimeout = a.connectionTimeout || ct, this.connect = this.connect.bind(this), this.disconnect = this.disconnect.bind(this);
      }

      return He(e, [{
        key: "connect",
        value: function value() {
          var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          Ve("hooks", "function", t);
          var n = new yt({
            hooks: t,
            id: this.userId,
            apiInstance: this.apiInstance,
            filesInstance: this.filesInstance,
            cursorsInstance: this.cursorsInstance,
            presenceInstance: this.presenceInstance,
            connectionTimeout: this.connectionTimeout
          });
          return Promise.all([n.establishUserSubscription(), n.establishCursorSubscription(), n.establishPresenceSubscription()]).then(function () {
            return e.currentUser = n, n;
          });
        }
      }, {
        key: "disconnect",
        value: function value() {
          this.currentUser && this.currentUser.disconnect();
        }
      }]), e;
    }()
  };
});